{********************************************************************}
{                                                                    }
{ written by TMS Software                                            }
{            copyright (c) 2016 - 2024                               }
{            Email : info@tmssoftware.com                            }
{            Web : https://www.tmssoftware.com                       }
{                                                                    }
{ The source code is given as is. The author is not responsible      }
{ for any possible damage done due to the use of this code.          }
{ The complete source code remains property of the author and may    }
{ not be distributed, published, given or sold in any form as such.  }
{ No parts of the source code can be included in any other component }
{ or application without written authorization of the author.        }
{********************************************************************}

unit WEBLib.TMSFNCChartEditor;

{$I WEBLib.TMSFNCDefines.inc}

{$IFDEF FMXLIB}
{$WARNINGS OFF}
{$HINTS OFF}
{$IF COMPILERVERSION > 30}
{$DEFINE DELPHIBERLIN}
{$IFEND}
{$HINTS ON}
{$WARNINGS ON}
{$ENDIF}

{$IFDEF VCLLIB}
{$DEFINE VCLWEBLIB}
{$ENDIF}
{$IFDEF CMNLIB}
{$DEFINE CMNWEBLIB}
{$ENDIF}
{$IFDEF WEBLIB}
{$DEFINE CMNWEBLIB}
{$DEFINE VCLWEBLIB}
{$ENDIF}

interface

uses
  Classes, WEBLib.TMSFNCCustomComponent, WEBLib.TMSFNCCustomControl, WEBLib.Controls,
  WEBLib.TMSFNCTypes, WEBLib.StdCtrls, WEBLib.ExtCtrls, WEBLib.Forms, WEBLib.TMSFNCGraphics, WEBLib.TMSFNCGraphicsTypes,
  WEBLib.TMSFNCChart, WEBLib.TMSFNCEditorButton, WEBLib.TMSFNCEditorPanel, WEBLib.TMSFNCEditorListView, WEBLib.TMSFNCBitmapEditor
  {$IFDEF FMXLIB}
  ,FMX.Types, FMX.Memo, FMX.ListBox, FMX.ComboEdit, FMX.SpinBox, FMX.Colors, FMX.Text, FMX.Edit, FMX.Layouts
  {$ENDIF}
  {$IFDEF VCLLIB}
  , Vcl.Samples.Spin
  {$ENDIF}
  {$IFDEF LCLLIB}
  , Spin, ColorBox
  {$ENDIF}
  {$IFDEF VCLLIB}
  , Vcl.ComCtrls
  {$ENDIF}
  {$IFNDEF LCLLIB}
  {$IFNDEF WEBLIB}
  ,UITypes
  {$ENDIF}
  ,Types
  {$ENDIF}
  ;

const
  MAJ_VER = 2; // Major version nr.
  MIN_VER = 0; // Minor version nr.
  REL_VER = 0; // Release nr.
  BLD_VER = 0; // Build nr.

  // version history
  // v1.0.0.0 : First Release
  // v1.0.1.0 : New : Updated design
  // v1.0.1.1 : Improved : Floating point spin edits for Lazarus
  // v2.0.0.0 : New : Divided Editors for more clear and organizable editing

  {$IFDEF VCLLIB}
  CHECKBOXSIZE = 13;
  CHECKBOXOFFSET = 6;
  SMALLHEIGHTSPAC = 5;
  MIDHEIGHTSPAC = 10;
  BIGHEIGHTSPAC = 15;
  {$ENDIF}
  {$IFDEF LCLLIB}
  CHECKBOXSIZE = 13;
  CHECKBOXOFFSET = 6;
  SMALLHEIGHTSPAC = 10;
  MIDHEIGHTSPAC = 15;
  BIGHEIGHTSPAC = 20;
  {$ENDIF}
  {$IFDEF WEBLIB}
  CHECKBOXSIZE = 17;
  CHECKBOXOFFSET = 6;
  SMALLHEIGHTSPAC = 15;
  MIDHEIGHTSPAC = 15;
  BIGHEIGHTSPAC = 20;
  {$ENDIF}
  {$IFDEF FMXLIB}
  CHECKBOXSIZE = 15;
  SMALLHEIGHTSPAC = 10;
  MIDHEIGHTSPAC = 15;
  BIGHEIGHTSPAC = 20;
  {$ENDIF}
  BIGDIV = 30;
  SMALLLBLSPACE = 10;
  MIDLBLSPACE = 20;
  BIGLBLSPACE = 30;
  SMALLHORSPACE = 60;
  MIDHORSPACE = 70;
  BIGHORSPACE = 80;
  SERIESLARGECONTROLWIDTH = 100;
  LARGECONTROLWIDTH = 100;
  SMALLCONTROLWIDTH = 45;
  VALUE_MBYES = 6;

resourcestring
  sTMSFNCChartEditorOK = 'OK';
  sTMSFNCChartEditorCancel = 'Cancel';
  sTMSFNCChartEditorApply = 'Apply';
  sTMSFNCChartEditorReset = 'Reset';
  sTMSFNCChartEditorChartType = '&Chart Type';
  sTMSFNCChartEditorLegacy = 'Legacy';

  sTMSFNCChartEditorLegend = '&Legend';
  sTMSFNCChartEditorGeneral = '&General';
  sTMSFNCChartEditorSeries = '&Series';
  sTMSFNCChartEditorTitle = '&Title';
  sTMSFNCChartEditorXAxis = '&X-Axis';
  sTMSFNCChartEditorYAxis = '&Y-Axis';
  sTMSFNCChartEditorAppearance = '&Appearance';

  sTMSFNCChartEditorSaveChartMessage = 'Are you sure you want to save the changes made?';
  sTMSFNCChartEditorCancelChartMessage = 'Are you sure you don''t want to save the changes made?';
  sTMSFNCChartEditorResetChartMessage = 'Are you sure you want to revert to the last saved settings?';

  TTMSFNCCHARTXAXISBITMAP = {$IFDEF WEBLIB}'data:image/svg+xml;base64,' + {$ENDIF} 'PHN2ZyBmaWxsPSJub25lIiBoZWlnaHQ9IjUxMiIgdmlld0JveD0iMCAwIDI0IDI0IiB3aWR0aD0iNTEyIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3L'
  + 'nczLm9yZy8xOTk5L3hsaW5rIj48ZyBmaWxsPSIjMDA3N0JFIj48cGF0aCBkPSJtNCAxNGMtLjYgMC0xLS40LTEtMXMuNC0xIDEtMSAxIC40IDEgMS0uNCAxLTEgMXoiLz48cGF0aCBkPSJtNCAxMGMtLjYgMC0xLS40LTEtMXMuNC0xIDEt'
  + 'MSAxIC40IDEgMS0uNCAxLTEgMXoiLz48cGF0aCBkPSJtNCA2Yy0uNiAwLTEtLjQtMS0xcy40LTEgMS0xIDEgLjQgMSAxLS40IDEtMSAxeiIvPjxwYXRoIGQ9Im0xNyAyMWMtLjMgMC0uNS0uMS0uNy0uMy0uNC0uNC0uNC0xIDAtMS40bDI'
  + 'uMy0yLjMtMi4zLTIuM2MtLjQtLjQtLjQtMSAwLTEuNHMxLS40IDEuNCAwbDMgM2MuNC40LjQgMSAwIDEuNGwtMyAzYy0uMi4yLS40LjMtLjcuM3oiLz48cGF0aCBkPSJtMjAgMThoLTE2Yy0uNiAwLTEtLjQtMS0xcy40LTEgMS0xaDE2Yy'
  + '42IDAgMSAuNCAxIDFzLS40IDEtMSAxeiIvPjwvZz48L3N2Zz4=';

  TTMSFNCCHARTYAXISBITMAP = {$IFDEF WEBLIB}'data:image/svg+xml;base64,' + {$ENDIF} 'PHN2ZyBmaWxsPSJub25lIiBoZWlnaHQ9IjUxMiIgdmlld0JveD0iMCAwIDI0IDI0IiB3aWR0aD0iNTEyIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3L'
    + 'nczLm9yZy8xOTk5L3hsaW5rIj48ZyBmaWxsPSIjMDA3N0JFIj48cGF0aCBkPSJtMTEgMjFjLS42IDAtMS0uNC0xLTFzLjQtMSAxLTEgMSAuNCAxIDEtLjQgMS0xIDF6Ii8+PHBhdGggZD0ibTE1IDIxYy0uNiAwLTEtLjQtMS0xcy40LTEg'
    + 'MS0xIDEgLjQgMSAxLS40IDEtMSAxeiIvPjxwYXRoIGQ9Im0xOSAyMWMtLjYgMC0xLS40LTEtMXMuNC0xIDEtMSAxIC40IDEgMS0uNCAxLTEgMXoiLz48cGF0aCBkPSJtMTAgOGMtLjMgMC0uNS0uMS0uNy0uM2wtMi4zLTIuMy0yLjMgMi4'
    + 'zYy0uNC40LTEgLjQtMS40IDBzLS40LTEgMC0xLjRsMy0zYy40LS40IDEtLjQgMS40IDBsMyAzYy40LjQuNCAxIDAgMS40LS4yLjItLjQuMy0uNy4zeiIvPjxwYXRoIGQ9Im03IDIxYy0uNiAwLTEtLjQtMS0xdi0xNmMwLS42LjQtMSAxLT'
    + 'FzMSAuNCAxIDF2MTZjMCAuNi0uNCAxLTEgMXoiLz48L2c+PC9zdmc+';

  TTMSFNCCHARTTITLEBITMAP = {$IFDEF WEBLIB}'data:image/svg+xml;base64,' + {$ENDIF} 'PHN2ZyBpZD0iYm9sZCIgZW5hYmxlLWJhY2tncm91bmQ9Im5ldyAwIDAgMjQgMjQiIGhlaWdodD0iNTEyIiB2aWV3Qm94PSIwIDAgMjQgMjQiIHdpZHRoPSI1MTIiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yM'
    + 'DAwL3N2ZyI+PGc+PHBhdGggZD0ibTEyIDloLTdjLS41NTIgMC0xIC40NDgtMSAxdjEuNWMwIC41NTIuNDQ4IDEgMSAxczEtLjQ0OCAxLTF2LS41aDEuNXY2aC0uNWMtLjU1MiAwLTEgLjQ0OC0xIDFzLjQ0OCAxIDEgMWgzYy41NTIgMCAx'
    + 'LS40NDggMS0xcy0uNDQ4LTEtMS0xaC0uNXYtNmgxLjV2LjVjMCAuNTUyLjQ0OCAxIDEgMXMxLS40NDggMS0xdi0xLjVjMC0uNTUyLS40NDgtMS0xLTF6IiBmaWxsPSIjMDA3N0JFIi8+PC9nPjxnPjxwYXRoIGQ9Im0xOSAxMWgtM2MtLjU'
    + '1MiAwLTEtLjQ0OC0xLTFzLjQ0OC0xIDEtMWgzYy41NTIgMCAxIC40NDggMSAxcy0uNDQ4IDEtMSAxeiIgZmlsbD0iIzAwNzdCRSIvPjwvZz48Zz48cGF0aCBkPSJtMTkgMTVoLTNjLS41NTIgMC0xLS40NDgtMS0xcy40NDgtMSAxLTFoM2'
    + 'MuNTUyIDAgMSAuNDQ4IDEgMXMtLjQ0OCAxLTEgMXoiIGZpbGw9IiMwMDc3QkUiLz48L2c+PGc+PHBhdGggZD0ibTE5IDE5aC0zYy0uNTUyIDAtMS0uNDQ4LTEtMXMuNDQ4LTEgMS0xaDNjLjU1MiAwIDEgLjQ0OCAxIDFzLS40NDggMS0xI'
    + 'DF6IiBmaWxsPSIjMDA3N0JFIi8+PC9nPjxnPjxwYXRoIGQ9Im0yMSAxaC0xOGMtMS42NTQgMC0zIDEuMzQ2LTMgM3YxNmMwIDEuNjU0IDEuMzQ2IDMgMyAzaDE4YzEuNjU0IDAgMy0xLjM0NiAzLTN2LTE2YzAtMS42NTQtMS4zNDYtMy0z'
    + 'LTN6bTAgMjBoLTE4Yy0uNTUxIDAtMS0uNDQ4LTEtMXYtMTRoMjB2MTRjMCAuNTUyLS40NDkgMS0xIDF6IiBmaWxsPSIjMDA3N0JFIi8+PC9nPjwvc3ZnPg==';

  TTMSFNCCHARTSERIESBITMAP = {$IFDEF WEBLIB}'data:image/svg+xml;base64,' + {$ENDIF} 'PHN2ZyBlbmFibGUtYmFja2dyb3VuZD0ibmV3IDAgMCA1MTIgNTEyIiBoZWlnaHQ9IjUxMiIgdmlld0JveD0iMCAwIDUxMiA1MTIiIHdpZHRoPSI1'
    + 'MTIiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+DQogIDxnIGlkPSJfeDMxXzA3MF94MkNfX0FuYWx5c2lzX3gyQ19fQnVzaW5lc3NfeDJDX19DaGFydF94M'
    + 'kNfX0dyYXBoX3gyQ19fR3Jvd3RoIj4NCiAgICA8Zz4NCiAgICAgIDxwYXRoIGQ9Im00OTYgNDg1LjVoLTQ3MHYtNDY5YzAtNS41MjMtNC40NzctMTAtMTAtMTBzLTEwIDQuND'
    + 'c3LTEwIDEwdjQ3OWMwIDUuNTIyIDQuNDc3IDEwIDEwIDEwaDQ4MGM1LjUyMiAwIDEwLTQuNDc4IDEwLTEwcy00LjQ3OC0xMC0xMC0xMHoiIGZpbGw9IiMwMDc3QkUiLz4NCiA'
    + 'gICAgIDxwYXRoIGQ9Im05NiA0NjUuNWMyNy41NyAwIDUwLTIyLjQzIDUwLTUwIDAtMTQuNjc1LTYuMzU2LTI3Ljg5Mi0xNi40NTgtMzcuMDQ3bDUwLjEyMi04NC43MDhjMjMu'
    + 'NjE2IDguMTg5IDQ5Ljc4NC0yLjM3NyA2MS4wNzgtMjQuOTY0bDU1LjM1MyAxNC43NjFjLTEuNzAyIDI4LjkzMiAyMS4zOTQgNTIuOTU4IDQ5LjkwNSA1Mi45NTggMjcuNTcgM'
    + 'CA1MC0yMi40MyA1MC01MCAwLTEyLjkwOS00LjkxOC0yNC42OTEtMTIuOTc5LTMzLjU3Mmw1Mi4wODEtNzEuMDIxYzYuMzY0IDIuOTQgMTMuNDQgNC41OTQgMjAuODk4IDQuNT'
    + 'k0IDI3LjU3IDAgNTAtMjIuNDMgNTAtNTBzLTIyLjQzLTUwLTUwLTUwLTUwIDIyLjQzLTUwIDUwYzAgMTIuOTEgNC45MTggMjQuNjkyIDEyLjk3OSAzMy41NzJsLTUyLjA4MiA'
    + '3MS4wMjFjLTI0LjQzLTExLjI4Ny01My41MTctMS4xMjEtNjUuNjQxIDIzLjEyNmwtNTUuMzUyLTE0Ljc2YzEuNjk3LTI5LjExNC0yMS41Ni01Mi45Ni00OS45MDUtNTIuOTYt'
    + 'MjcuNTcgMC01MCAyMi40My01MCA1MCAwIDE0LjY3NSA2LjM1NiAyNy44OTMgMTYuNDU4IDM3LjA0OGwtNTAuMTIyIDg0LjcwN2MtNS4xMjItMS43NzctMTAuNjE1LTIuNzU1L'
    + 'TE2LjMzNS0yLjc1NS0yNy41NyAwLTUwIDIyLjQzLTUwIDUwczIyLjQzIDUwIDUwIDUwem0zNjAtMzU5YzE2LjU0MiAwIDMwIDEzLjQ1OCAzMCAzMHMtMTMuNDU4IDMwLTMwID'
    + 'MwLTMwLTEzLjQ1OC0zMC0zMCAxMy40NTgtMzAgMzAtMzB6bS0xMTAgMTUwYzE2LjU0MiAwIDMwIDEzLjQ1OCAzMCAzMHMtMTMuNDU4IDMwLTMwIDMwLTMwLTEzLjQ1OC0zMC0'
    + 'zMCAxMy40NTgtMzAgMzAtMzB6bS0xNTAtNDBjMTYuNTQyIDAgMzAgMTMuNDU4IDMwIDMwcy0xMy40NTggMzAtMzAgMzAtMzAtMTMuNDU4LTMwLTMwIDEzLjQ1OC0zMCAzMC0z'
    + 'MHptLTEwMCAxNjljMTYuNTQyIDAgMzAgMTMuNDU4IDMwIDMwcy0xMy40NTggMzAtMzAgMzAtMzAtMTMuNDU4LTMwLTMwIDEzLjQ1OC0zMCAzMC0zMHoiIGZpbGw9IiMwMDc3Q'
    + 'kUiLz4NCiAgICA8L2c+DQogIDwvZz4NCjwvc3ZnPg==';

  {$IFNDEF WEBLIB}
  TTMSFNCCHARTLEGENDBITMAP = 'PHN2ZyBlbmFibGUtYmFja2dyb3VuZD0ibmV3IDAgMCA1MTIgNTEyIiB2aWV3Qm94PSIwIDAgNTEyIDUxMiIgeG1sbnM9Imh0dHA6Ly93d3cudzMub'
    + '3JnLzIwMDAvc3ZnIj4NCiAgPGcgaWQ9Il94MzFfOF9NYXBfTGVnZW5kIj4NCiAgICA8Zz4NCiAgICAgIDxwYXRoIGQ9Im0xNTYuODA3IDE0Ny43MTItNTMuOTQyLTExNi43MDljLTEuO'
    + 'TgxLTQuMjc4LTYuMDc4LTYuODg5LTEwLjc2MS02Ljg4OXMtOC44MjUgMi42MTItMTAuODA2IDYuODg5bC01My45NDIgMTE2LjcwOWMtMi4xNjEgNC43MjgtMS4wMzYgMTAuMjIxIDIuN'
    + 'zkyIDEzLjczMyAzLjgyNyAzLjUxMiA5LjQ1NSA0LjA5NyAxMy45NTggMS41MzFsNDcuOTk4LTI3Ljc4MSA0Ny45OTggMjcuNzgxYzQuNDU4IDIuNTY2IDEwLjA4NiAxLjk4MSAxMy45M'
    + 'TMtMS41MzEgMy44NzMtMy41MTMgNC45OTgtOS4wMDYgMi43OTItMTMuNzMzem0tNjEuMzI2LTI2LjE2MWMtMS4wMzYtLjU4NS0yLjIwNi0uOTAxLTMuMzc3LS45MDEtMS4xNyAwLTIuM'
    + 'zQxLjMxNS0zLjM3Ny45MDFsLTQ2LjkxNyAyNy4xNTEgNTAuMjk0LTEwOC44MjggNTAuMjk1IDEwOC44Mjl6IiBmaWxsPSIjMDA3N0JFIi8+DQogICAgICA8cGF0aCBkPSJtNDgxLjEzM'
    + 'iA4Ny41ODRoLTI2Ni41MjJjLTMuNzI5IDAtNi43NTQgMy4wMjMtNi43NTQgNi43NTRzMy4wMjUgNi43NTQgNi43NTQgNi43NTRoMjY2LjUyMmMzLjcyOSAwIDYuNzU0LTMuMDIzIDYuN'
    + 'zU0LTYuNzU0cy0zLjAyNi02Ljc1NC02Ljc1NC02Ljc1NHoiIGZpbGw9IiMwMDc3QkUiLz4NCiAgICAgIDxwYXRoIGQ9Im00ODEuMTMyIDI1MS45NTZoLTI2Ni41MjJjLTMuNzI5IDAtN'
    + 'i43NTQgMy4wMjMtNi43NTQgNi43NTRzMy4wMjUgNi43NTQgNi43NTQgNi43NTRoMjY2LjUyMmMzLjcyOSAwIDYuNzU0LTMuMDIzIDYuNzU0LTYuNzU0cy0zLjAyNi02Ljc1NC02Ljc1N'
    + 'C02Ljc1NHoiIGZpbGw9IiMwMDc3QkUiLz4NCiAgICAgIDxwYXRoIGQ9Im00ODEuMTMyIDQxMy4xMzJoLTI2Ni41MjJjLTMuNzI5IDAtNi43NTQgMy4wMjMtNi43NTQgNi43NTRzMy4wM'
    + 'jUgNi43NTQgNi43NTQgNi43NTRoMjY2LjUyMmMzLjcyOSAwIDYuNzU0LTMuMDIzIDYuNzU0LTYuNzU0cy0zLjAyNi02Ljc1NC02Ljc1NC02Ljc1NHoiIGZpbGw9IiMwMDc3QkUiLz4NC'
    + 'iAgICAgIDxwYXRoIGQ9Im0xNjAuMDk0IDIwNC40OXYxMDguNDY5YzAgNy41NjQtNi4xNjkgMTMuNzMzLTEzLjc3OCAxMy43MzNoLTEwOC40NjljLTcuNTY0IDAtMTMuNzMzLTYuMTY5L'
    + 'TEzLjczMy0xMy43MzN2LTEwOC40NjljMC03LjYwOSA2LjE2OS0xMy43NzggMTMuNzMzLTEzLjc3OGgxMDguNDY5YzcuNjA5IDAgMTMuNzc4IDYuMTY4IDEzLjc3OCAxMy43Nzh6IiBma'
    + 'WxsPSIjMDA3N0JFIi8+DQogICAgICA8cGF0aCBkPSJtOTIuMTA0IDM1MS45MDZjLTM3LjUwNyAwLTY3Ljk5IDMwLjQ4My02Ny45OSA2Ny45OSAwIDM3LjQ2MiAzMC40ODMgNjcuOTkgN'
    + 'jcuOTkgNjcuOTkgMzcuNDYyIDAgNjcuOTktMzAuNTI4IDY3Ljk5LTY3Ljk5IDAtMzcuNTA3LTMwLjUyOC02Ny45OS02Ny45OS02Ny45OXptMCAxMjIuNDcyYy0zMC4wMzIgMC01NC40O'
    + 'DItMjQuNDQ5LTU0LjQ4Mi01NC40ODJzMjQuNDQ5LTU0LjQ4MiA1NC40ODItNTQuNDgyIDU0LjQ4MiAyNC40NDkgNTQuNDgyIDU0LjQ4MmMwIDMwLjAzMi0yNC40NDkgNTQuNDgyLTU0L'
    + 'jQ4MiA1NC40ODJ6IiBmaWxsPSIjMDA3N0JFIi8+DQogICAgPC9nPg0KICA8L2c+DQogIDxnIGlkPSJMYXllcl8xIiAvPg0KPC9zdmc+';
  {$ENDIF}

  {$IFDEF WEBLIB}
  TTMSFNCCHARTLEGENDBITMAP = 'data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiPz4KPHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vc'
    + 'mcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIiB3aWR0aD0iMTAwcHgiIGhlaWdodD'
    + '0iMTAwcHgiIHZpZXdCb3g9IjAgMCAxMDAgMTAwIiB2ZXJzaW9uPSIxLjEiPgo8ZyBpZD0ic3VyZmFjZTEiPgo8cGF0aCBzdHlsZT0'
    + 'iIHN0cm9rZTpub25lO2ZpbGwtcnVsZTpub256ZXJvO2ZpbGw6cmdiKDAlLDQ2LjY2NjY2NyUsNzQuNTA5ODA1JSk7ZmlsbC1vcGFj'
    + 'aXR5OjE7IiBkPSJNIDMwLjYyNSAyOC44NTE1NjIgTCAyMC4wODk4NDQgNi4wNTQ2ODggQyAxOS43MDMxMjUgNS4yMTg3NSAxOC45M'
    + 'DIzNDQgNC43MTA5MzggMTcuOTg4MjgxIDQuNzEwOTM4IEMgMTcuMDc0MjE5IDQuNzEwOTM4IDE2LjI2NTYyNSA1LjIxODc1IDE1Lj'
    + 'g3ODkwNiA2LjA1NDY4OCBMIDUuMzQzNzUgMjguODUxNTYyIEMgNC45MjE4NzUgMjkuNzczNDM4IDUuMTQwNjI1IDMwLjg0NzY1NiA'
    + '1Ljg4NjcxOSAzMS41MzEyNSBDIDYuNjM2NzE5IDMyLjIxODc1IDcuNzM0Mzc1IDMyLjMzMjAzMSA4LjYxMzI4MSAzMS44MzIwMzEg'
    + 'TCAxNy45ODgyODEgMjYuNDA2MjUgTCAyNy4zNjMyODEgMzEuODMyMDMxIEMgMjguMjM0Mzc1IDMyLjMzMjAzMSAyOS4zMzIwMzEgM'
    + 'zIuMjE4NzUgMzAuMDgyMDMxIDMxLjUzMTI1IEMgMzAuODM1OTM4IDMwLjg0NzY1NiAzMS4wNTg1OTQgMjkuNzczNDM4IDMwLjYyNS'
    + 'AyOC44NTE1NjIgWiBNIDE4LjY0ODQzOCAyMy43NDIxODggQyAxOC40NDUzMTIgMjMuNjI1IDE4LjIxODc1IDIzLjU2MjUgMTcuOTg'
    + '4MjgxIDIzLjU2MjUgQyAxNy43NjE3MTkgMjMuNTYyNSAxNy41MzEyNSAyMy42MjUgMTcuMzI4MTI1IDIzLjc0MjE4OCBMIDguMTY3'
    + 'OTY5IDI5LjA0Mjk2OSBMIDE3Ljk4ODI4MSA3Ljc4OTA2MiBMIDI3LjgxMjUgMjkuMDQyOTY5IFogTSAxOC42NDg0MzggMjMuNzQyM'
    + 'Tg4ICIvPgo8cGF0aCBzdHlsZT0iIHN0cm9rZTpub25lO2ZpbGwtcnVsZTpub256ZXJvO2ZpbGw6cmdiKDAlLDQ2LjY2NjY2NyUsNz'
    + 'QuNTA5ODA1JSk7ZmlsbC1vcGFjaXR5OjE7IiBkPSJNIDkzLjk3MjY1NiAxNy4xMDU0NjkgTCA0MS45MTQwNjIgMTcuMTA1NDY5IEM'
    + 'gNDEuMTg3NSAxNy4xMDU0NjkgNDAuNTk3NjU2IDE3LjY5NTMxMiA0MC41OTc2NTYgMTguNDI1NzgxIEMgNDAuNTk3NjU2IDE5LjE1'
    + 'MjM0NCA0MS4xODc1IDE5Ljc0NjA5NCA0MS45MTQwNjIgMTkuNzQ2MDk0IEwgOTMuOTcyNjU2IDE5Ljc0NjA5NCBDIDk0LjY5OTIxO'
    + 'SAxOS43NDYwOTQgOTUuMjg5MDYyIDE5LjE1MjM0NCA5NS4yODkwNjIgMTguNDI1NzgxIEMgOTUuMjg5MDYyIDE3LjY5NTMxMiA5NC'
    + '42OTkyMTkgMTcuMTA1NDY5IDkzLjk3MjY1NiAxNy4xMDU0NjkgWiBNIDkzLjk3MjY1NiAxNy4xMDU0NjkgIi8+CjxwYXRoIHN0eWx'
    + 'lPSIgc3Ryb2tlOm5vbmU7ZmlsbC1ydWxlOm5vbnplcm87ZmlsbDpyZ2IoMCUsNDYuNjY2NjY3JSw3NC41MDk4MDUlKTtmaWxsLW9w'
    + 'YWNpdHk6MTsiIGQ9Ik0gOTMuOTcyNjU2IDQ5LjIxMDkzOCBMIDQxLjkxNDA2MiA0OS4yMTA5MzggQyA0MS4xODc1IDQ5LjIxMDkzO'
    + 'CA0MC41OTc2NTYgNDkuODAwNzgxIDQwLjU5NzY1NiA1MC41MzEyNSBDIDQwLjU5NzY1NiA1MS4yNTc4MTIgNDEuMTg3NSA1MS44ND'
    + 'c2NTYgNDEuOTE0MDYyIDUxLjg0NzY1NiBMIDkzLjk3MjY1NiA1MS44NDc2NTYgQyA5NC42OTkyMTkgNTEuODQ3NjU2IDk1LjI4OTA'
    + '2MiA1MS4yNTc4MTIgOTUuMjg5MDYyIDUwLjUzMTI1IEMgOTUuMjg5MDYyIDQ5LjgwMDc4MSA5NC42OTkyMTkgNDkuMjEwOTM4IDkz'
    + 'Ljk3MjY1NiA0OS4yMTA5MzggWiBNIDkzLjk3MjY1NiA0OS4yMTA5MzggIi8+CjxwYXRoIHN0eWxlPSIgc3Ryb2tlOm5vbmU7Zmlsb'
    + 'C1ydWxlOm5vbnplcm87ZmlsbDpyZ2IoMCUsNDYuNjY2NjY3JSw3NC41MDk4MDUlKTtmaWxsLW9wYWNpdHk6MTsiIGQ9Ik0gOTMuOT'
    + 'cyNjU2IDgwLjY5MTQwNiBMIDQxLjkxNDA2MiA4MC42OTE0MDYgQyA0MS4xODc1IDgwLjY5MTQwNiA0MC41OTc2NTYgODEuMjgxMjU'
    + 'gNDAuNTk3NjU2IDgyLjAwNzgxMiBDIDQwLjU5NzY1NiA4Mi43MzgyODEgNDEuMTg3NSA4My4zMjgxMjUgNDEuOTE0MDYyIDgzLjMy'
    + 'ODEyNSBMIDkzLjk3MjY1NiA4My4zMjgxMjUgQyA5NC42OTkyMTkgODMuMzI4MTI1IDk1LjI4OTA2MiA4Mi43MzgyODEgOTUuMjg5M'
    + 'DYyIDgyLjAwNzgxMiBDIDk1LjI4OTA2MiA4MS4yODEyNSA5NC42OTkyMTkgODAuNjkxNDA2IDkzLjk3MjY1NiA4MC42OTE0MDYgWi'
    + 'BNIDkzLjk3MjY1NiA4MC42OTE0MDYgIi8+CjxwYXRoIHN0eWxlPSIgc3Ryb2tlOm5vbmU7ZmlsbC1ydWxlOm5vbnplcm87ZmlsbDp'
    + 'yZ2IoMCUsNDYuNjY2NjY3JSw3NC41MDk4MDUlKTtmaWxsLW9wYWNpdHk6MTsiIGQ9Ik0gMzEuMjY5NTMxIDM5LjkzNzUgTCAzMS4y'
    + 'Njk1MzEgNjEuMTI1IEMgMzEuMjY5NTMxIDYyLjYwMTU2MiAzMC4wNjI1IDYzLjgwODU5NCAyOC41NzgxMjUgNjMuODA4NTk0IEwgN'
    + 'y4zOTA2MjUgNjMuODA4NTk0IEMgNS45MTQwNjIgNjMuODA4NTk0IDQuNzEwOTM4IDYyLjYwMTU2MiA0LjcxMDkzOCA2MS4xMjUgTC'
    + 'A0LjcxMDkzOCAzOS45Mzc1IEMgNC43MTA5MzggMzguNDUzMTI1IDUuOTE0MDYyIDM3LjI1IDcuMzkwNjI1IDM3LjI1IEwgMjguNTc'
    + '4MTI1IDM3LjI1IEMgMzAuMDYyNSAzNy4yNSAzMS4yNjk1MzEgMzguNDUzMTI1IDMxLjI2OTUzMSAzOS45Mzc1IFogTSAzMS4yNjk1'
    + 'MzEgMzkuOTM3NSAiLz4KPHBhdGggc3R5bGU9IiBzdHJva2U6bm9uZTtmaWxsLXJ1bGU6bm9uemVybztmaWxsOnJnYigwJSw0Ni42N'
    + 'jY2NjclLDc0LjUwOTgwNSUpO2ZpbGwtb3BhY2l0eToxOyIgZD0iTSAxNy45ODgyODEgNjguNzMwNDY5IEMgMTAuNjY0MDYyIDY4Lj'
    + 'czMDQ2OSA0LjcxMDkzOCA3NC42ODM1OTQgNC43MTA5MzggODIuMDExNzE5IEMgNC43MTA5MzggODkuMzI4MTI1IDEwLjY2NDA2MiA'
    + '5NS4yODkwNjIgMTcuOTg4MjgxIDk1LjI4OTA2MiBDIDI1LjMwNDY4OCA5NS4yODkwNjIgMzEuMjY5NTMxIDg5LjMyODEyNSAzMS4y'
    + 'Njk1MzEgODIuMDExNzE5IEMgMzEuMjY5NTMxIDc0LjY4MzU5NCAyNS4zMDQ2ODggNjguNzMwNDY5IDE3Ljk4ODI4MSA2OC43MzA0N'
    + 'jkgWiBNIDE3Ljk4ODI4MSA5Mi42NTIzNDQgQyAxMi4xMjUgOTIuNjUyMzQ0IDcuMzQ3NjU2IDg3Ljg3NSA3LjM0NzY1NiA4Mi4wMT'
    + 'E3MTkgQyA3LjM0NzY1NiA3Ni4xNDQ1MzEgMTIuMTI1IDcxLjM3MTA5NCAxNy45ODgyODEgNzEuMzcxMDk0IEMgMjMuODU1NDY5IDc'
    + 'xLjM3MTA5NCAyOC42Mjg5MDYgNzYuMTQ0NTMxIDI4LjYyODkwNiA4Mi4wMTE3MTkgQyAyOC42Mjg5MDYgODcuODc1IDIzLjg1NTQ2'
    + 'OSA5Mi42NTIzNDQgMTcuOTg4MjgxIDkyLjY1MjM0NCBaIE0gMTcuOTg4MjgxIDkyLjY1MjM0NCAiLz4KPC9nPgo8L3N2Zz4K';
  {$ENDIF}

//  TTMSFNCCHARTTYPEBITMAP = {$IFDEF WEBLIB}'data:image/svg+xml;base64,' + {$ENDIF} 'PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCA1MTIuMDA3IDUxMi4wMDciIHN0eWxlPSJlbmFibGUtY'
//    + 'mFja2dyb3VuZDpuZXcgMCAwIDUxMi4wMDcgNTEyLjAwNyIgeG1sOnNwYWNlPSJwcmVzZXJ2ZSI+CiAgICA8cGF0aCBzdHlsZT0iZmlsbDojMDA3N2JlIiBkPSJNMzQuMjg2IDMzMi44O'
//    + 'TFoODUuMjg5VjUwMy40N0gzNC4yODZ6TTE1My42OTEgMjEzLjQ4Nmg4NS4yODl2Mjg5Ljk4M2gtODUuMjg5ek0yNzMuMDk2IDI5OC43NzVoODUuMjg5djIwNC42OTRoLTg1LjI4OXpNM'
//    + 'zkyLjUgMTc5LjM3aDg1LjI4OXYzMjQuMDk5SDM5Mi41eiIvPgogICAgPGNpcmNsZSBzdHlsZT0iZmlsbDojMDA3N2JlIiBjeD0iNzYuOTMiIGN5PSIxOTYuNDI4IiByPSIzNC4xMTYiL'
//    + 'z4KICAgIDxwYXRoIHN0eWxlPSJmaWxsOiMwMDc3YmUiIGQ9Ik0xNzYuNzM2IDEwNC45ODFjMTUuNDM3IDEwLjgwNiAzNi43MDkgNy4wNTMgNDcuNTE1LTguMzg0IDEwLjgwNi0xNS40M'
//    + 'zcgNy4wNTMtMzYuNzA4LTguMzg0LTQ3LjUxNXMtMzYuNzA4LTcuMDUzLTQ3LjUxNSA4LjM4NGMtMTAuODA2IDE1LjQzOC03LjA1NCAzNi43MDkgOC4zODQgNDcuNTE1eiIvPgogICAgP'
//    + 'GNpcmNsZSBzdHlsZT0iZmlsbDojMDA3N2JlIiBjeD0iMzE1Ljc0IiBjeT0iMTYyLjMxMyIgcj0iMzQuMTE2Ii8+CiAgICA8Y2lyY2xlIHN0eWxlPSJmaWxsOiMwMDc3YmUiIGN4PSI0M'
//    + 'zUuMTQ1IiBjeT0iNDIuOTA4IiByPSIzNC4xMTYiLz4KICAgIDxwYXRoIHN0eWxlPSJmaWxsOiMwMDc3YmUiIGQ9Ik00ODYuMjg1IDQ5NC45NDl2LTMxNS41N2E4LjUzMiA4LjUzMiAwI'
//    + 'DAgMC04LjUyOS04LjUyOWgtODUuMjg5YTguNTMyIDguNTMyIDAgMCAwLTguNTI5IDguNTI5djMxNS41N0gzNjYuODhWMjk4Ljc4NGE4LjUzMiA4LjUzMiAwIDAgMC04LjUyOS04LjUyO'
//    + 'WgtODUuMjg5YTguNTMyIDguNTMyIDAgMCAwLTguNTI5IDguNTI5djE5Ni4xNjVoLTE3LjA1OFYyMTMuNDk1YTguNTMyIDguNTMyIDAgMCAwLTguNTI5LTguNTI5aC04NS4yODlhOC41M'
//    + 'zIgOC41MzIgMCAwIDAtOC41MjkgOC41MjlWNDk0Ljk1SDEyOC4wN1YzMzIuOWE4LjUzMiA4LjUzMiAwIDAgMC04LjUyOS04LjUyOWgtODUuMjlhOC41MzIgOC41MzIgMCAwIDAtOC41M'
//    + 'jkgOC41Mjl2MTYyLjA1SC4xMzZ2MTcuMDU4aDUxMS43MzZWNDk0Ljk1aC0yNS41ODd6bS00NDMuNTA1IDB2LTE1My41Mmg2OC4yMzFWNDk0Ljk1SDQyLjc4em0xMTkuNDA1IDBWMjIyL'
//    + 'jAyNGg2OC4yMzFWNDk0Ljk1aC02OC4yMzF6bTExOS40MDUgMFYzMDcuMzEzaDY4LjIzMXYxODcuNjM2SDI4MS41OXptMTE5LjQwNSAwVjE4Ny45MDhoNjguMjMxdjMwNy4wNDFoLTY4L'
//    + 'jIzMXoiLz4KICAgIDxwYXRoIHN0eWxlPSJmaWxsOiMwMDc3YmUiIGQ9Ik03Ni44OTYgMjM5LjA4MWMyMy41NDggMCA0Mi42NDUtMTkuMDk2IDQyLjY0NS00Mi42NDVhNDIuNjI3IDQyL'
//    + 'jYyNyAwIDAgMC03LjA3LTIzLjUxNGw2MC4zNjgtNjAuMzc2YTQyLjE4NCA0Mi4xODQgMCAwIDAgMjMuMzc4IDcuMTMgNDMuMjQgNDMuMjQgMCAwIDAgNy40ODgtLjY1NyA0Mi4zNCA0M'
//    + 'i4zNCAwIDAgMCAyMS42NDYtMTAuODE1bDUwLjYwMiAzOC45Yy04LjQ0NCAyMS45ODggMi41MzMgNDYuNjUzIDI0LjUxMiA1NS4wOTcgMjEuOTg4IDguNDQ0IDQ2LjY1My0yLjUzMyA1N'
//    + 'S4wOTctMjQuNTEyYTQyLjY0NCA0Mi42NDQgMCAwIDAtNC4yOS0zOC44OTJsNjAuMzUxLTYwLjM1MWMxOS43MDIgMTMuMDQxIDQ2LjIzNSA3LjY0MiA1OS4yNzYtMTIuMDYgMTMuMDQxL'
//    + 'TE5LjcwMiA3LjY0Mi00Ni4yMzUtMTIuMDYtNTkuMjc2LTE5LjcwMi0xMy4wNDEtNDYuMjM1LTcuNjQyLTU5LjI3NiAxMi4wNmE0Mi43NjQgNDIuNzY0IDAgMCAwIDAgNDcuMjE2bC02M'
//    + 'C4zNTEgNjAuMzUxYy0xNi45MDQtMTEuMTczLTM5LjMzNS04LjkxMy01My42NjQgNS40MTYtLjE2Mi4xNjItLjI1Ni4zNS0uNDA5LjUwM0wyMzUuMjcgOTQuMzI4YzkuNTc4LTIxLjUxO'
//    + 'C0uMTAyLTQ2LjcyMS0yMS42MTItNTYuMjk5cy00Ni43MjEuMTAyLTU2LjI5OSAyMS42MTJhNDIuNjIzIDQyLjYyMyAwIDAgMCAzLjM5NSA0MC44NzFsLTYwLjM0MiA2MC4zNTFjLTE5L'
//    + 'jY1MS0xMi45OS00Ni4wOTktNy41OTEtNTkuMDg4IDEyLjA2cy03LjU5MSA0Ni4wOTkgMTIuMDYgNTkuMDg4YTQyLjUwMSA0Mi41MDEgMCAwIDAgMjMuNTEyIDcuMDd6TTQzNS4xMTEgM'
//    + 'TcuMzI5YzE0LjEzMiAwIDI1LjU4NyAxMS40NTQgMjUuNTg3IDI1LjU4N3MtMTEuNDU0IDI1LjU4Ny0yNS41ODcgMjUuNTg3LTI1LjU4Ny0xMS40NTQtMjUuNTg3LTI1LjU4NyAxMS40N'
//    + 'TUtMjUuNTg3IDI1LjU4Ny0yNS41ODd6TTMxNS43MDYgMTM2LjczNGMxNC4xMzIgMCAyNS41ODcgMTEuNDU0IDI1LjU4NyAyNS41ODdhMjUuNTcyIDI1LjU3MiAwIDAgMS03LjQ5NyAxO'
//    + 'C4wOThjLTEwLjEyNCA5LjY1NS0yNi4wNTYgOS42NTUtMzYuMTggMC05Ljk5Ni05Ljk4Ny0xMC4wMDQtMjYuMTkyLS4wMDktMzYuMTg4YTI1LjYxNCAyNS42MTQgMCAwIDEgMTguMDk5L'
//    + 'TcuNDk3em0tMTQwLjM2MS03NC4zOGEyNS40MzUgMjUuNDM1IDAgMCAxIDE2LjUxMi0xMC41MjUgMjYuNDE3IDI2LjQxNyAwIDAgMSA0LjQ5NS0uMzg0IDI1LjQ5NiAyNS40OTYgMCAwI'
//    + 'DEgMTQuNjI3IDQuNjMxYzExLjU3NCA4LjEwMiAxNC4zODggMjQuMDYgNi4yNzcgMzUuNjM0LTguMTExIDExLjU3NC0yNC4wNiAxNC4zODgtMzUuNjM0IDYuMjc3LTExLjU3My04LjA5N'
//    + 'C0xNC4zODgtMjQuMDUxLTYuMjc3LTM1LjYzMyAwIC4wMDggMCAuMDA4IDAgMHpNNTguODA2IDE3OC4zMzhjOS45OTYtOS45ODcgMjYuMjAxLTkuOTg3IDM2LjE4OC4wMDlzOS45ODcgM'
//    + 'jYuMjAxLS4wMDkgMzYuMTg4Yy0xMC4xMjQgOS42NTUtMjYuMDU2IDkuNjU1LTM2LjE4IDAtOS45OTYtOS45ODctMTAuMDA0LTI2LjE5Mi0uMDA5LTM2LjE4OC4wMDIgMCAuMDAyIDAgL'
//    + 'jAxLS4wMDl6Ii8+Cjwvc3ZnPgo=';

  TTMSFNCCHARTTYPEBITMAP = {$IFDEF WEBLIB}'data:image/svg+xml;base64,' + {$ENDIF} 'PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIj'
    + '4KICAgIDxwYXRoIHN0eWxlPSJzdHJva2U6bm9uZTtmaWxsLXJ1bGU6bm9uemVybztmaWxsOiMwMDc3YmU7ZmlsbC1vcGFjaXR5OjEiIGQ9Ik'
    + '02LjY5NSA2NS4wMTZoMTYuNjZ2MzMuMzE2SDYuNjk1Wm0yMy4zMi0yMy4zMmgxNi42NnY1Ni42MzZoLTE2LjY2Wm0yMy4zMjUgMTYuNjZoMT'
    + 'YuNjU2djM5Ljk3Nkg1My4zNFpNNzYuNjYgMzUuMDNoMTYuNjU2djYzLjMwMUg3Ni42NlpNMjEuNjg4IDM4LjM2M2E2LjY2MyA2LjY2MyAwID'
    + 'EgMC0xMy4zMjUgMCA2LjY2MiA2LjY2MiAwIDEgMCAxMy4zMjUgMFpNMzQuNTIgMjAuNTA0YTYuNjYgNi42NiAwIDAgMCA5LjI3Ny0xLjYzNy'
    + 'A2LjY2NSA2LjY2NSAwIDAgMC0xMC45MTgtNy42NDUgNi42NjUgNi42NjUgMCAwIDAgMS42NCA5LjI4MlpNNjguMzMyIDMxLjcwM2E2LjY2My'
    + 'A2LjY2MyAwIDAgMC02LjY2NC02LjY2NCA2LjY2MyA2LjY2MyAwIDEgMCAwIDEzLjMyNGMzLjY4IDAgNi42NjQtMi45OCA2LjY2NC02LjY2Wk'
    + '05MS42NTIgOC4zNzljMC0zLjY4LTIuOTg0LTYuNjYtNi42NjQtNi42NmE2LjY2MiA2LjY2MiAwIDEgMCAwIDEzLjMyNCA2LjY2NSA2LjY2NS'
    + 'AwIDAgMCA2LjY2NC02LjY2NFptMCAwIi8+CiAgICA8cGF0aCBzdHlsZT0ic3Ryb2tlOm5vbmU7ZmlsbC1ydWxlOm5vbnplcm87ZmlsbDojMD'
    + 'A3N2JlO2ZpbGwtb3BhY2l0eToxIiBkPSJNOTQuOTc3IDk2LjY2OFYzNS4wMzVjMC0uOTIyLS43NDctMS42NjgtMS42NjgtMS42NjhINzYuNj'
    + 'UyYy0uOTE4IDAtMS42NjQuNzQ2LTEuNjY0IDEuNjY4djYxLjYzM2gtMy4zMzJWNTguMzU1YzAtLjkxNy0uNzQ2LTEuNjY0LTEuNjY4LTEuNj'
    + 'Y0SDUzLjMzMmMtLjkyMiAwLTEuNjY0Ljc0Ni0xLjY2OCAxLjY2NHYzOC4zMTNoLTMuMzI4VjQxLjY5OWExLjY3IDEuNjcgMCAwIDAtMS42Nj'
    + 'gtMS42NjhIMzAuMDEyYy0uOTIyIDAtMS42NjguNzQ2LTEuNjY4IDEuNjY4djU0Ljk2OWgtMy4zMzJWNjUuMDJjMC0uOTIyLS43NDYtMS42Nj'
    + 'gtMS42NjQtMS42NjhINi42OWMtLjkyMSAwLTEuNjY4Ljc0Ni0xLjY2OCAxLjY2OHYzMS42NDhILjAyN1YxMDBoOTkuOTQ2di0zLjMzMlptLT'
    + 'g2LjYyMiAwVjY2LjY4NEgyMS42OHYyOS45ODRabTIzLjMyIDBWNDMuMzYzaDEzLjMyOXY1My4zMDVabTIzLjMyMSAwVjYwLjAyaDEzLjMyOH'
    + 'YzNi42NDhabTIzLjMyIDBWMzYuNjk5aDEzLjMyOXY1OS45NjlabTAgMCIvPgogICAgPHBhdGggc3R5bGU9InN0cm9rZTpub25lO2ZpbGwtcn'
    + 'VsZTpub256ZXJvO2ZpbGw6IzAwNzdiZTtmaWxsLW9wYWNpdHk6MSIgZD0iTTE1LjAyIDQ2LjY5NWE4LjMzIDguMzMgMCAwIDAgOC4zMjgtOC'
    + '4zMjhjMC0xLjYzMy0uNDgtMy4yMy0xLjM4My00LjU5NEwzMy43NTggMjEuOThhOC4yMjcgOC4yMjcgMCAwIDAgNi4wMjcgMS4yNjYgOC4yND'
    + 'MgOC4yNDMgMCAwIDAgNC4yMjctMi4xMTNsOS44ODMgNy41OTdhOC4zMzEgOC4zMzEgMCAwIDAgNC43ODkgMTAuNzYyIDguMzMxIDguMzMxID'
    + 'AgMCAwIDEwLjc2MS00Ljc4OSA4LjMyMyA4LjMyMyAwIDAgMC0uODQtNy41OTRsMTEuNzktMTEuNzg5YTguMzU1IDguMzU1IDAgMSAwLTIuMz'
    + 'U2LTIuMzU1TDY2LjI1IDI0Ljc1NGE4LjMyMyA4LjMyMyAwIDAgMC0xMC40OCAxLjA1OGMtLjAzMi4wMzItLjA1MS4wNjctLjA3OS4wOThsLT'
    + 'kuNzQyLTcuNDg4QTguMzMgOC4zMyAwIDAgMCA0MS43MyA3LjQyNmE4LjMzNSA4LjMzNSAwIDAgMC0xMC45OTYgNC4yMjIgOC4zMTQgOC4zMT'
    + 'QgMCAwIDAgLjY2NCA3Ljk4NUwxOS42MTMgMzEuNDE4YTguMzI4IDguMzI4IDAgMSAwLTQuNTk0IDE1LjI3N1pNODQuOTggMy4zODNhNC45OT'
    + 'kgNC45OTkgMCAxIDEgLjAwMiA5Ljk5NSA0Ljk5OSA0Ljk5OSAwIDAgMS0uMDAyLTkuOTk1Wk02MS42NiAyNi43MDdhNC45OTMgNC45OTMgMC'
    + 'AwIDEgNC45OTYgNC45OTYgNC45ODMgNC45ODMgMCAwIDEtMS40NiAzLjUzNSA1LjExOSA1LjExOSAwIDAgMS03LjA2NyAwIDQuOTk4IDQuOT'
    + 'k4IDAgMCAxLS4wMDQtNy4wNyA1LjAxNiA1LjAxNiAwIDAgMSAzLjUzNS0xLjQ2MVpNMzQuMjQ2IDEyLjE4YTQuOTc1IDQuOTc1IDAgMCAxID'
    + 'QuMTAyLTIuMTMzIDQuOTk4IDQuOTk4IDAgMCAxIDQuMDg2IDcuODYzIDQuOTk1IDQuOTk1IDAgMCAxLTYuOTYxIDEuMjI3IDQuOTkzIDQuOT'
    + 'kzIDAgMCAxLTEuMjI3LTYuOTU3Wk0xMS40ODQgMzQuODMyYTQuOTk4IDQuOTk4IDAgMSAxIDcuMDY3IDcuMDcgNS4xMjYgNS4xMjYgMCAwID'
    + 'EtNy4wNjcgMCA0Ljk5OCA0Ljk5OCAwIDAgMSAwLTcuMDdabTAgMCIvPgo8L3N2Zz4K';

//    TTMSFNCCHARTAPPEARANCEBITMAP = {$IFDEF WEBLIB}'data:image/svg+xml;base64,' + {$ENDIF} 'PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iaXNvLTg4NTktMSI/Pg0KPCEtLSBHZW5lcmF0b3I6IEFkb2JlIElsbHVzdHJhdG9yIDE5LjAuM'
//    + 'CwgU1ZHIEV4cG9ydCBQbHVnLUluIC4gU1ZHIFZlcnNpb246IDYuMDAgQnVpbGQgMCkgIC0tPg0KPHN2ZyB2ZXJzaW9uPSIxLjEiIGlkPSJMYXllcl8xIiB4bWxucz0iaHR0cDovL3d3d'
//    + 'y53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIiB4PSIwcHgiIHk9IjBweCINCgkgdmlld0JveD0iMCAwIDUxMiA1MTIiIHN0e'
//    + 'WxlPSJlbmFibGUtYmFja2dyb3VuZDpuZXcgMCAwIDUxMiA1MTI7IiB4bWw6c3BhY2U9InByZXNlcnZlIj4NCjxnPg0KCTxnPg0KCQk8cG9seWdvbiBwb2ludHM9IjMyLjU1NCwzOTQuN'
//    + 'TkzIDAsNTEyIDExNy40MDcsNDc5LjQ0NiIgZmlsbD0iIzAwNzdCRSIvPg0KCTwvZz4NCjwvZz4NCjxnPg0KCTxnPg0KCQk8cGF0aCBkPSJNNDk4Ljg3NCwzNC4zMzlsLTIxLjIxMy0yM'
//    + 'S4yMTNjLTE3LjUwMS0xNy41MDEtNDYuMTM5LTE3LjUwMS02My42NCwwbC0xNS4xNSwxNS4xNWw4NC44NTMsODQuODUzbDE1LjE1LTE1LjE1DQoJCQlDNTE2LjM3NSw4MC40NzgsNTE2L'
//    + 'jM3NSw1MS44NCw0OTguODc0LDM0LjMzOXoiIGZpbGw9IiMwMDc3QkUiLz4NCgk8L2c+DQo8L2c+DQo8Zz4NCgk8Zz4NCgkJPHJlY3QgeD0iMzk0LjQ4MiIgeT0iNDIuNTE2IiB0cmFuc'
//    + '2Zvcm09Im1hdHJpeCgwLjcwNzEgLTAuNzA3MSAwLjcwNzEgMC43MDcxIDQ3LjQ0NDggMzE5LjU3MjcpIiB3aWR0aD0iMzAiIGhlaWdodD0iMTE5Ljk5OSIgZmlsbD0iIzAwNzdCRSIvP'
//    + 'g0KCTwvZz4NCjwvZz4NCjxnPg0KCTxnPg0KCQk8cmVjdCB4PSI2NC40MTMiIHk9IjI3OS4wOTMiIHRyYW5zZm9ybT0ibWF0cml4KDAuNzA3MSAtMC43MDcxIDAuNzA3MSAwLjcwNzEgL'
//    + 'TEzNi4wOTkzIDI3NC42MTIpIiB3aWR0aD0iMzk4LjA0NiIgaGVpZ2h0PSI0NSIgZmlsbD0iIzAwNzdCRSIvPg0KCTwvZz4NCjwvZz4NCjxnPg0KCTxnPg0KCQk8cmVjdCB4PSIxMS4zO'
//    + 'SIgeT0iMjI2LjA1NCIgdHJhbnNmb3JtPSJtYXRyaXgoMC43MDcxIC0wLjcwNzEgMC43MDcxIDAuNzA3MSAtMTE0LjEyNTIgMjIxLjU4NDIpIiB3aWR0aD0iMzk4LjA0NiIgaGVpZ2h0P'
//    + 'SI0NSIgZmlsbD0iIzAwNzdCRSIvPg0KCTwvZz4NCjwvZz4NCjxnPg0KCTxnPg0KCQk8cGF0aCBkPSJNNDgzLjQ0NywzNDUuNTY3Yy0yMi4wNzUtMjIuMDc1LTUyLjEwMS0zMS4zNDktO'
//    + 'DAuODYtMjcuODI4bC00MC41MjMtNDAuNTI0bC04NC44NTMsODQuODUzbDQwLjUyMyw0MC41MjQNCgkJCWMtMi45NDYsMjQuMDU5LDMuMDcsNDkuMDAyLDE4LjAzNyw2OS40MzhsODkuM'
//    + 'zQtODkuMzRsNzYuMjE5LDc2LjIxOUM1MjAuMDc4LDQyMi4yNjUsNTE0LjEyMSwzNzYuMjQxLDQ4My40NDcsMzQ1LjU2N3oiIGZpbGw9IiMwMDc3QkUiLz4NCgk8L2c+DQo8L2c+DQo8Z'
//    + 'z4NCgk8Zz4NCgkJPHBhdGggZD0iTTQwMy44OTgsNDQ2LjMzbC00Ni45MDgsNDYuOTA4YzI5Ljk1LDIxLjkzNSw2OS41ODEsMjQuNjQsMTAxLjkxNCw4LjA5OEw0MDMuODk4LDQ0Ni4zM'
//    + '3oiIGZpbGw9IiMwMDc3QkUiLz4NCgk8L2c+DQo8L2c+DQo8Zz4NCgk8Zz4NCgkJPHBhdGggZD0iTTUzLjA5NiwxMC42NjVsNTUuMDA2LDU1LjAwNmw0Ni45MDgtNDYuOTA5QzEyNS4wN'
//    + 'i0zLjE3Myw4NS40My01Ljg3OCw1My4wOTYsMTAuNjY1eiIgZmlsbD0iIzAwNzdCRSIvPg0KCTwvZz4NCjwvZz4NCjxnPg0KCTxnPg0KCQk8cGF0aCBkPSJNMTk0LjI2NiwxMDkuNDA4Y'
//    + 'zIuOTQ2LTI0LjA1OS0zLjA3LTQ5LjAwMi0xOC4wMzctNjkuNDM4bC04OS4zNCw4OS4zNEwxMC42Nyw1My4wOTENCgkJCUMtOC4wNzgsODkuNzM1LTIuMTIxLDEzNS43NTksMjguNTUyL'
//    + 'DE2Ni40MzNjMjIuMDc2LDIyLjA3NSw1Mi4xMDIsMzEuMzQ5LDgwLjg2MSwyNy44MjhsNDAuNTIzLDQwLjUyM2w4NC44NTMtODQuODUzDQoJCQlMMTk0LjI2NiwxMDkuNDA4eiIgZmlsb'
//    + 'D0iIzAwNzdCRSIvPg0KCTwvZz4NCjwvZz4NCjwvc3ZnPg0K';

  TTMSFNCCHARTAPPEARANCEBITMAP = {$IFDEF WEBLIB}'data:image/svg+xml;base64,' + {$ENDIF} 'PHN2ZyBoZWlnaHQ9IjUxMiIgdmlld0JveD0iMCAwIDY0IDY0IiB3aWR0aD0iNTEyIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciP'
    + 'jxnIGlkPSJMYXllcl8zMiIgZGF0YS1uYW1lPSJMYXllciAzMiI+PHBhdGggZD0ibTI1IDIxLjc3MWEzLjQ0NSAzLjQ0NSAwIDAgMCAuNDg5IDEuNzY5bDEuNjExIDIuNjc3YTYuMzQxI'
    + 'DYuMzQxIDAgMCAxIC0yLjkzOSA5LjA4OSAzNS43MzIgMzUuNzMyIDAgMCAwIC0yMC44ODMgMjUuNDE2IDM1LjczMyAzNS43MzMgMCAwIDAgMjUuNDE2LTIwLjg4IDYuMzQgNi4zNCAwI'
    + 'DAgMSA5LjA4OC0yLjk0MmwyLjY3OSAxLjYwN2EzLjQyOSAzLjQyOSAwIDAgMCAyLjkuMjYybC0xOC4xNDctMTguMTQxYTMuMjY2IDMuMjY2IDAgMCAwIC0uMjE0IDEuMTQzem0tMTYgM'
    + 'zUuMjI5YTIgMiAwIDEgMSAyLTIgMiAyIDAgMCAxIC0yIDJ6IiBmaWxsPSIjMDA3N0JFIi8+PHBhdGggZD0ibTM1LjE3MiAxMy44NThoMy42NTd2MjYuMjg0aC0zLjY1N3oiIHRyYW5zZ'
    + 'm9ybT0ibWF0cml4KC43MDcgLS43MDcgLjcwNyAuNzA3IC04LjI1NSAzNC4wNzEpIiBmaWxsPSIjMDA3N0JFIi8+PHBhdGggZD0ibTU0LjMgMjZhMS45NDMgMS45NDMgMCAwIDAgLTEuO'
    + 'Dg3IDEuNDczIDMuMzM2IDMuMzM2IDAgMCAxIC02LjU2NC0uNTcxbC0uNzY2LTEwLjcwMmEuMjE5LjIxOSAwIDAgMCAtLjQxMS0uMDUxbC0uMTkzLjU4MWEzLjMyNSAzLjMyNSAwIDAgM'
    + 'SAtNi40NzktMS4wNTUgMTEuMjU5IDExLjI1OSAwIDAgMSAuNTgyLTMuNTgxIDguMTgyIDguMTgyIDAgMCAwIC40MTgtMi41ODEgMS41MTUgMS41MTUgMCAwIDAgLTEuNTEzLTEuNTEzY'
    + 'y0uMDI2IDAtLjA1MSAwLS4wNzcgMGwtNyA3IDE4LjU5IDE4LjU4NiA3LjU4Ni03LjU4NnoiIGZpbGw9IiMwMDc3QkUiLz48cGF0aCBkPSJtNTguNjkzIDIwLjEwNy0zLjQ1MS44NjNhM'
    + 'SAxIDAgMCAxIC0xLjA3NC0xLjUyNWwxLjU0NS0yLjMxOC0xLjk1NC0xLjk1NC00LjM4OCAxLjc1NmExIDEgMCAwIDEgLTEuMTcxLTEuNTI5bDIuNDgtMy4zMDYtOC42OC04LjY4LTIuO'
    + 'TYzIDIuOTYzYTMuNSAzLjUgMCAwIDEgMS45NjMgMy4xMzYgMTAuMTYgMTAuMTYgMCAwIDEgLS41MjEgMy4yMTMgOS4yOTQgOS4yOTQgMCAwIDAgLS40NzkgMi45NDkgMS4zMjUgMS4zM'
    + 'jUgMCAwIDAgMi41ODIuNDE5bC4xOTItLjU4MWEyLjIxMSAyLjIxMSAwIDAgMSA0LjMuNTQxbC43NjUgMTAuNzA1YTEuMzM3IDEuMzM3IDAgMCAwIDIuNjMxLjIyOSAzLjkzNyAzLjkzN'
    + 'yAwIDAgMSAzLjgzLTIuOTg4aDQuMjg3bDItMnoiIGZpbGw9IiMwMDc3QkUiLz48cGF0aCBkPSJtNTIgNDZhMyAzIDAgMCAwIDYgMGMwLTEuMDkyLTEuNTYxLTMuOTQyLTMtNi4xOTItM'
    + 'S40MzkgMi4yNS0zIDUuMS0zIDYuMTkyeiIgZmlsbD0iIzAwNzdCRSIvPjwvZz48L3N2Zz4=';
type
  TTMSFNCChartEditor = class;

  {$IFDEF FMXLIB}
  TTMSFNCChartEditorParent = TFmxObject;
  {$ENDIF}
  {$IFDEF CMNWEBLIB}
  TTMSFNCChartEditorParent = TWinControl;
  {$ENDIF}

  {$IFNDEF LCLLIB}
  [ComponentPlatformsAttribute(TMSPlatformsDesktop)]
  {$ENDIF}
  TTMSFNCChartEditor = class(TTMSFNCCustomComponent)
  private
    {$IFNDEF WEBLIB}
    FOldCursor: TCursor;
    {$ENDIF}
    FBitmapEditor: TTMSFNCBitmapEditor;
    FGeneralPanel{, FGeneralBottomPanel}: TTMSFNCEditorPanel;
    {FLegacyBtn, }FTypeBtn, FAppearanceBtn, FLegendBtn, FTitleBtn, FXAxisBtn, FYAxisBtn, FSeriesBtn: TTMSFNCEditorButton;
    frm: TTMSFNCCustomDesignerForm;
    FPanel: TTMSFNCEditorPanel;
    FChart: TTMSFNCChart;
    FCopyChart: TTMSFNCChart;
    FButtonOk, FButtonCancel, FButtonApply, FButtonReset: TTMSFNCEditorButton;
    FModified: Boolean;
    procedure SetChart(const Value: TTMSFNCChart);
    function CancelChartMessage: Boolean;
    function SaveChartMessage: Boolean;
    function ResetChartMessage: Boolean;
  protected
    function GetInstance: NativeUInt; override;
    procedure RegisterRuntimeClasses; override;
    procedure Notification(AComponent: TComponent; AOperation: TOperation); override;
    procedure BuildEditor(AParent: TTMSFNCChartEditorParent); virtual;
    procedure Initialize; virtual;
    procedure SetAppearance; virtual;
    {$IFNDEF FMXLIB}
    procedure DoFormKeyDown(Sender: TObject; var Key: Word; Shift: TShiftState);
    {$ENDIF}
    {$IFDEF FMXLIB}
    procedure DoFormKeyDown(Sender: TObject; var Key: Word; var KeyChar: Char; Shift: TShiftState);
    {$ENDIF}
    procedure DoButtonHandleTypeAcceleratorKey(Sender: TObject); virtual;
    procedure DoButtonHandleAppearanceAcceleratorKey(Sender: TObject); virtual;
    procedure DoButtonHandleTitleAcceleratorKey(Sender: TObject); virtual;
    procedure DoButtonHandleLegendAcceleratorKey(Sender: TObject); virtual;
    procedure DoButtonHandleXAxisAcceleratorKey(Sender: TObject); virtual;
    procedure DoButtonHandleYAxisAcceleratorKey(Sender: TObject); virtual;
    procedure DoButtonHandleSeriesAcceleratorKey(Sender: TObject); virtual;

    procedure DoButtonApplyClick(Sender: TObject); virtual;
    procedure DoButtonResetClick(Sender: TObject); virtual;
    procedure DoButtonOKClick(Sender: TObject); virtual;
    procedure DoButtonCancelClick(Sender: TObject); virtual;
    procedure DoButtonTypeClick(Sender: TObject); virtual;
    procedure DoButtonTitleClick(Sender: TObject); virtual;
    procedure DoButtonAppearanceClick(Sender: TObject); virtual;
//    procedure DoButtonLegacyClick(Sender: TObject); virtual;
    procedure DoButtonLegendClick(Sender: TObject); virtual;
    procedure DoButtonXAxisClick(Sender: TObject); virtual;
    procedure DoButtonYAxisClick(Sender: TObject); virtual;
    procedure DoButtonSeriesClick(Sender: TObject); virtual;
    procedure DoListBoxChange(Sender: TObject);
    procedure DoListBoxItemSelectedChange(Sender: TObject; AIndex: Integer; AItem: TTMSFNCEditorListItem; ASelected: Boolean);
    procedure DoPointsItemSelectedChange(Sender: TObject; AIndex: Integer; AItem: TTMSFNCEditorListItem; ASelected: Boolean);
    procedure DoAnnoItemSelectedChange(Sender: TObject; AIndex: Integer; AItem: TTMSFNCEditorListItem; ASelected: Boolean);
//    procedure CreateGeneralBottomPanel(AParent: TTMSFNCChartEditorParent);
    procedure CreateBottomPanel(AParent: TTMSFNCChartEditorParent);
    {$IFDEF WEBLIB}
    procedure ApplyCSS(ACSS: string); virtual;
    {$ENDIF}
    function GetDocURL: string; override;
    function GetTipsURL: string; override;
    procedure SetWaitCursor; virtual;
    procedure SetOldCursor; virtual;
  public
    constructor Create(AOwner: TComponent); override;
    destructor Destroy; override;
    {$IFDEF WEBLIB}
    procedure Execute(AProc: TModalResultProc = nil);
    {$ELSE}
    function Execute: TModalResult;
    {$ENDIF}
    procedure Assign(Source: TPersistent); override;
  published
    property Chart: TTMSFNCChart read FChart write SetChart;
  end;

  TTMSFNCChartEditorForm = class(TTMSFNCCustomDesignerForm)
  {$IFDEF WEBLIB}
  private
    FChartEditor: TTMSFNCChartEditor;
  protected
    procedure Loaded; override;
    procedure LoadDFMValues; override;
  public
    constructor CreateDialogNew(AChartEditor: TTMSFNCChartEditor; ACaption: string); reintroduce; virtual;
  {$ENDIF}
  end;

  TTMSFNCChartEditorDialog = class(TTMSFNCChartEditor);

implementation

uses
  WEBLib.TMSFNCUtils, WEBLib.Graphics, SysUtils, WEBLib.TMSFNCEditorsTools,
  WEBLib.TMSFNCChartTypeEditor, WEBLib.TMSFNCChartAppearanceEditor, {WEBLib.TMSFNCChartLegacyEditor,}
  WEBLib.TMSFNCChartLegendEditor, WEBLib.TMSFNCChartTitleEditor, WEBLib.TMSFNCChartAxisEditor, WEBLib.TMSFNCChartSeriesEditor
  {$IFDEF FMXLIB}
  ,WEBLib.Dialogs, FMX.Platform
  {$ENDIF}
  {$IFDEF VCLLIB}
  ,WEBLib.Dialogs, VCL.Themes
  {$ENDIF}
  {$IFDEF WEBLIB}
  ,WEBLib.Dialogs
  {$ENDIF}
  {$IFDEF LCLLIB}
  ,Dialogs
  {$ENDIF}
  {$IFDEF WEBLIB}
  ,WEBLib.WebTools
  {$ENDIF}
  {$IFNDEF FMXMOBILE}
  {$IFDEF DELPHIBERLIN}
  ,FMX.DialogService.Sync
  {$ENDIF}
  {$ENDIF}
  ;
{$R TMSFNCChartEditor.res}

type
  TTMSFNCChartOpen = class(TTMSFNCChart);

{ TTMSFNCChartEditor }

function TranslateTextEx(AText: String): String;
begin
  {$IFDEF FMXLIB}
  Result := TranslateText(AText);
  {$ENDIF}
  {$IFDEF CMNWEBLIB}
  Result := AText;
  {$ENDIF}
end;

procedure TTMSFNCChartEditor.Notification(AComponent: TComponent;
  AOperation: TOperation);
begin
  inherited;
  if (AOperation = opRemove) and (AComponent = FChart) then
    FChart := nil;
end;

procedure TTMSFNCChartEditor.RegisterRuntimeClasses;
begin
  inherited;
  RegisterClass(TTMSFNCChartEditor);
end;

function TTMSFNCChartEditor.ResetChartMessage: Boolean;
var
  res: Integer;
begin
  {$IFNDEF WEBLIB}
  Result := False;
  res := TTMSFNCUtils.Message(sTMSFNCChartEditorResetChartMessage, TMsgDlgType.mtConfirmation, [TMsgDlgBtn.mbYes, TMsgDlgBtn.mbNo], 0);
  if res = VALUE_MBYES then
  {$ENDIF}
    Result := True;
end;

procedure TTMSFNCChartEditor.Assign(Source: TPersistent);
begin
  if (Source is TTMSFNCChartEditor) then
    FChart := (Source as TTMSFNCChartEditor).Chart;
end;

procedure TTMSFNCChartEditor.BuildEditor(AParent: TTMSFNCChartEditorParent);
var
  bs: TBytesStream;
begin
  if Assigned(AParent) then
  begin

    //                  General Panel
    //**************************************************

    FGeneralPanel := TTMSFNCEditorPanel.Create(AParent);
    FGeneralPanel.PanelPosition := eppCenter;
    {$IFDEF FMXLIB}
    FGeneralPanel.Align := TAlignLayout.Client;
    {$ENDIF}
    {$IFDEF CMNWEBLIB}
    FGeneralPanel.Align := alClient;
    {$ENDIF}
    FGeneralPanel.Parent := AParent;

    FTypeBtn := TTMSFNCEditorButton.Create(FGeneralPanel);
    FTypeBtn.Parent := FGeneralPanel;
    FTypeBtn.Text := TranslateTextEx(sTMSFNCChartEditorChartType);
    FTypeBtn.Left := BIGDIV;
    FTypeBtn.Top := BIGDIV;
    FTypeBtn.Width := 120;
    FTypeBtn.Height := 120;
    FTypeBtn.OnClick := @DoButtonTypeClick;
    FTypeBtn.BitmapMargins.Top := 22;
    FTypeBtn.BitmapMargins.Left := 16;
    FTypeBtn.BitmapMargins.Right := 16;
    FTypeBtn.BitmapMargins.Bottom := 16;
    FTypeBtn.OnHandleAcceleratorKey := DoButtonHandleTypeAcceleratorKey;
    {$IFDEF WEBLIB}
    FTypeBtn.Bitmap.LoadFromResource(TTMSFNCCHARTTYPEBITMAP, HInstance);
    {$ENDIF}
    {$IFNDEF WEBLIB}
    bs := TBytesStream.Create(TTMSFNCUtils.Decode64ToBytes(TTMSFNCCHARTTYPEBITMAP));
    try
      FTypeBtn.Bitmap.LoadFromStream(bs);
    finally
      bs.Free
    end;
    {$ENDIF};

    FAppearanceBtn := TTMSFNCEditorButton.Create(FGeneralPanel);
    FAppearanceBtn.Parent := FGeneralPanel;
    FAppearanceBtn.Text := TranslateTextEx(sTMSFNCChartEditorAppearance);
    FAppearanceBtn.Left := FTypeBtn.Left + FTypeBtn.Width + BIGDIV;
    FAppearanceBtn.Top := BIGDIV;
    FAppearanceBtn.Width := 120;
    FAppearanceBtn.Height := 120;
    FAppearanceBtn.OnClick := @DoButtonAppearanceClick;
    FAppearanceBtn.BitmapMargins.Top := 20;
    FAppearanceBtn.BitmapMargins.Left := 16;
    FAppearanceBtn.BitmapMargins.Right := 16;
    FAppearanceBtn.BitmapMargins.Bottom := 8;
    FAppearanceBtn.OnHandleAcceleratorKey := DoButtonHandleAppearanceAcceleratorKey;
    {$IFDEF WEBLIB}
    FAppearanceBtn.Bitmap.LoadFromResource(TTMSFNCCHARTAPPEARANCEBITMAP, HInstance);
    {$ENDIF}
    {$IFNDEF WEBLIB}
    bs := TBytesStream.Create(TTMSFNCUtils.Decode64ToBytes(TTMSFNCCHARTAPPEARANCEBITMAP));
    try
      FAppearanceBtn.Bitmap.LoadFromStream(bs);
    finally
      bs.Free
    end;
    {$ENDIF};

    FLegendBtn := TTMSFNCEditorButton.Create(FGeneralPanel);
    FLegendBtn.Parent := FGeneralPanel;
    FLegendBtn.Text := TranslateTextEx(sTMSFNCChartEditorLegend);
    FLegendBtn.Left := FAppearanceBtn.Left + FAppearanceBtn.Width + BIGDIV;
    FLegendBtn.Top := BIGDIV;
    FLegendBtn.Width := 120;
    FLegendBtn.Height := 120;
    FLegendBtn.OnClick := @DoButtonLegendClick;
    FLegendBtn.BitmapMargins.Top := 22;
    FLegendBtn.BitmapMargins.Left := 8;
    FLegendBtn.BitmapMargins.Right := 8;
    FLegendBtn.BitmapMargins.Bottom := 8;
    FLegendBtn.OnHandleAcceleratorKey := DoButtonHandleLegendAcceleratorKey;
    {$IFDEF WEBLIB}
    FLegendBtn.Bitmap.LoadFromResource(TTMSFNCCHARTLEGENDBITMAP, HInstance);
    {$ENDIF}
    {$IFNDEF WEBLIB}
    bs := TBytesStream.Create(TTMSFNCUtils.Decode64ToBytes(TTMSFNCCHARTLEGENDBITMAP));
    try
      FLegendBtn.Bitmap.LoadFromStream(bs);
    finally
      bs.Free
    end;
    {$ENDIF};

    FTitleBtn := TTMSFNCEditorButton.Create(FGeneralPanel);
    FTitleBtn.Parent := FGeneralPanel;
    FTitleBtn.Text := TranslateTextEx(sTMSFNCChartEditorTitle);
    FTitleBtn.Left := FTypeBtn.Left;
    FTitleBtn.Top := FTypeBtn.Top + FTypeBtn.Height + BIGDIV;
    FTitleBtn.Width := 120;
    FTitleBtn.Height := 120;
    FTitleBtn.OnClick := @DoButtonTitleClick;
    FTitleBtn.BitmapMargins.Top := 22;
    FTitleBtn.BitmapMargins.Left := 8;
    FTitleBtn.BitmapMargins.Right := 8;
    FTitleBtn.BitmapMargins.Bottom := 8;
    FTitleBtn.OnHandleAcceleratorKey := DoButtonHandleTitleAcceleratorKey;
    {$IFDEF WEBLIB}
    FTitleBtn.Bitmap.LoadFromResource(TTMSFNCCHARTTITLEBITMAP, HInstance);
    {$ENDIF}
    {$IFNDEF WEBLIB}
    bs := TBytesStream.Create(TTMSFNCUtils.Decode64ToBytes(TTMSFNCCHARTTITLEBITMAP));
    try
      FTitleBtn.Bitmap.LoadFromStream(bs);
    finally
      bs.Free
    end;
    {$ENDIF};

    FXAxisBtn := TTMSFNCEditorButton.Create(FGeneralPanel);
    FXAxisBtn.Parent := FGeneralPanel;
    FXAxisBtn.Text := TranslateTextEx(sTMSFNCChartEditorXAxis);
    FXAxisBtn.Left := FTitleBtn.Left + FTitleBtn.Width + BIGDIV;
    FXAxisBtn.Top := FTitleBtn.Top;
    FXAxisBtn.Width := 120;
    FXAxisBtn.Height := 120;
    FXAxisBtn.OnClick := @DoButtonXAxisClick;
    FXAxisBtn.BitmapMargins.Top := 20;
    FXAxisBtn.BitmapMargins.Left := 8;
    FXAxisBtn.BitmapMargins.Right := 8;
    FXAxisBtn.BitmapMargins.Bottom := 4;
    FXAxisBtn.OnHandleAcceleratorKey := DoButtonHandleXAxisAcceleratorKey;
    {$IFDEF WEBLIB}
    FXAxisBtn.Bitmap.LoadFromResource(TTMSFNCCHARTXAXISBITMAP, HInstance);
    {$ENDIF}
    {$IFNDEF WEBLIB}
    bs := TBytesStream.Create(TTMSFNCUtils.Decode64ToBytes(TTMSFNCCHARTXAXISBITMAP));
    try
      FXAxisBtn.Bitmap.LoadFromStream(bs);
    finally
      bs.Free
    end;
    {$ENDIF};

    FYAxisBtn := TTMSFNCEditorButton.Create(FGeneralPanel);
    FYAxisBtn.Parent := FGeneralPanel;
    FYAxisBtn.Text := TranslateTextEx(sTMSFNCChartEditorYAxis);
    FYAxisBtn.Left := FXAxisBtn.Left + FXAxisBtn.Width + BIGDIV;
    FYAxisBtn.Top := FTitleBtn.Top;
    FYAxisBtn.Width := 120;
    FYAxisBtn.Height := 120;
    FYAxisBtn.OnClick := @DoButtonYAxisClick;
    FYAxisBtn.BitmapMargins.Top := 20;
    FYAxisBtn.BitmapMargins.Left := 8;
    FYAxisBtn.BitmapMargins.Right := 8;
    FYAxisBtn.BitmapMargins.Bottom := 4;
    FYAxisBtn.OnHandleAcceleratorKey := DoButtonHandleYAxisAcceleratorKey;
    {$IFDEF WEBLIB}
    FYAxisBtn.Bitmap.LoadFromResource(TTMSFNCCHARTYAXISBITMAP, HInstance);
    {$ENDIF}
    {$IFNDEF WEBLIB}
    bs := TBytesStream.Create(TTMSFNCUtils.Decode64ToBytes(TTMSFNCCHARTYAXISBITMAP));
    try
      FYAxisBtn.Bitmap.LoadFromStream(bs);
    finally
      bs.Free
    end;
    {$ENDIF};

    FSeriesBtn := TTMSFNCEditorButton.Create(FGeneralPanel);
    FSeriesBtn.Parent := FGeneralPanel;
    FSeriesBtn.Text := TranslateTextEx(sTMSFNCChartEditorSeries);
    FSeriesBtn.Left := FTypeBtn.Left;
    FSeriesBtn.Top := FTitleBtn.Top + FTitleBtn.Height + BIGDIV;
    FSeriesBtn.Width := 120;
    FSeriesBtn.Height := 120;
    FSeriesBtn.OnClick := @DoButtonSeriesClick;
    FSeriesBtn.BitmapMargins.Top := 20;
    FSeriesBtn.BitmapMargins.Left := 16;
    FSeriesBtn.BitmapMargins.Right := 16;
    FSeriesBtn.BitmapMargins.Bottom := 16;
    FSeriesBtn.OnHandleAcceleratorKey := DoButtonHandleSeriesAcceleratorKey;
    {$IFDEF WEBLIB}
    FSeriesBtn.Bitmap.LoadFromResource(TTMSFNCCHARTSERIESBITMAP, HInstance);
    {$ENDIF}
    {$IFNDEF WEBLIB}
    bs := TBytesStream.Create(TTMSFNCUtils.Decode64ToBytes(TTMSFNCCHARTSERIESBITMAP));
    try
      FSeriesBtn.Bitmap.LoadFromStream(bs);
    finally
      bs.Free
    end;
    {$ENDIF};

    //                     Bottom Panel
    //-------------------------------------------------------

    {$IFNDEF VCLLIB}
    CreateBottomPanel(AParent);
//    CreateGeneralBottomPanel(AParent);
    {$ENDIF}
    {$IFDEF VCLLIB}
//    CreateGeneralBottomPanel(AParent);
    CreateBottomPanel(AParent);
    {$ENDIF}

    Initialize;
    SetAppearance;
  end;
end;

procedure TTMSFNCChartEditor.DoButtonOKClick(Sender: TObject);
begin
  if Assigned(frm) then
  begin
    {$IFNDEF WEBLIB}
    if FModified then
    begin
      if SaveChartMessage then
    {$ENDIF}
      frm.ModalResult := mrOk;
    {$IFNDEF WEBLIB}
    end
    else
      frm.ModalResult := mrOk;
    {$ENDIF}
  end;
end;

procedure TTMSFNCChartEditor.DoButtonCancelClick(Sender: TObject);
begin
  if Assigned(frm) then
  begin
    {$IFNDEF WEBLIB}
    if FModified then
    begin
      if CancelChartMessage then
    {$ENDIF}
      frm.ModalResult := mrCancel;
    {$IFNDEF WEBLIB}
    end
    else
      frm.ModalResult := mrCancel;
    {$ENDIF}
  end;
end;

procedure TTMSFNCChartEditor.DoButtonHandleAppearanceAcceleratorKey(Sender: TObject);
begin
  DoButtonAppearanceClick(Sender);
end;

procedure TTMSFNCChartEditor.DoButtonHandleLegendAcceleratorKey(Sender: TObject);
begin
  DoButtonLegendClick(Sender);
end;

procedure TTMSFNCChartEditor.DoButtonHandleSeriesAcceleratorKey(Sender: TObject);
begin
  DoButtonSeriesClick(Sender);
end;

procedure TTMSFNCChartEditor.DoButtonHandleTitleAcceleratorKey(Sender: TObject);
begin
  DoButtonTitleClick(Sender);
end;

procedure TTMSFNCChartEditor.DoButtonHandleTypeAcceleratorKey(Sender: TObject);
begin
  DoButtonTypeClick(Sender);
end;

procedure TTMSFNCChartEditor.DoButtonHandleXAxisAcceleratorKey(Sender: TObject);
begin
  DoButtonXAxisClick(Sender);
end;

procedure TTMSFNCChartEditor.DoButtonHandleYAxisAcceleratorKey(Sender: TObject);
begin
  DoButtonYAxisClick(Sender);
end;

procedure TTMSFNCChartEditor.DoButtonLegendClick(Sender: TObject);
var
  legE: TTMSFNCChartLegendEditor;
begin
  legE := TTMSFNCChartLegendEditor.Create(Self);
  legE.Chart := FChart;
  legE.Execute;
end;

{$IFDEF WEBLIB}
procedure TTMSFNCChartEditor.ApplyCSS(ACSS: string);
begin
//  FButtonOK.ElementClassName := 'IDEButton IDEFont';
//  FButtonCancel.ElementClassName := 'IDEButton IDEFont';
//  FButtonOpen.ElementClassName := 'IDEButton IDEFont';
//  FButtonClear.ElementClassName := 'IDEButton IDEFont';
//
//  FTopPanel.ElementClassName := 'IDEBkg';
//  FPanel.ElementClassName := 'IDEBkg';
end;
{$ENDIF}

function TTMSFNCChartEditor.CancelChartMessage: Boolean;
var
  res: Integer;
begin
  {$IFNDEF WEBLIB}
  Result := False;
  res := TTMSFNCUtils.Message(sTMSFNCChartEditorCancelChartMessage, TMsgDlgType.mtConfirmation, [TMsgDlgBtn.mbYes, TMsgDlgBtn.mbNo], 0);
  if res = VALUE_MBYES then
  {$ENDIF}
    Result := True;
end;

constructor TTMSFNCChartEditor.Create(AOwner: TComponent);
begin
  inherited;
  FBitmapEditor := TTMSFNCBitmapEditor.Create(Self);
end;

procedure TTMSFNCChartEditor.CreateBottomPanel(AParent: TTMSFNCChartEditorParent);
begin
  FPanel := TTMSFNCEditorPanel.Create(AParent);
  {$IFDEF FMXLIB}
  FPanel.Align := TAlignLayout.Bottom;
  FPanel.PanelPosition := eppBottom;
  {$ENDIF}
  {$IFDEF CMNWEBLIB}
  FPanel.PanelPosition := eppCenter;
  FPanel.Align := alBottom;
  {$ENDIF}
  FPanel.Parent := AParent;

  FPanel.Height := 37;

  FButtonCancel := TTMSFNCEditorButton.Create(FPanel);
//    FButtonCancel.ModalResult := mrCancel;
  FButtonCancel.Parent := FPanel;
  FButtonCancel.Text := TranslateTextEx(sTMSFNCChartEditorCancel);
  {$IFDEF FMXLIB}
  FButtonCancel.Align := TAlignLayout.Right;
  {$ENDIF}
  {$IFDEF CMNWEBLIB}
  FButtonCancel.Align := alRight;
  FButtonCancel.Left := 99;
  {$IFDEF VCLWEBLIB}
  FButtonCancel.AlignWithMargins := True;
  {$ENDIF}
  {$ENDIF}
  {$IFDEF LCLLIB}
  FButtonCancel.BorderSpacing.Right := 5;
  FButtonCancel.BorderSpacing.Top := 5;
  FButtonCancel.BorderSpacing.Bottom := 5;
  FButtonCancel.BorderSpacing.Left := 5;
  {$ENDIF}
  {$IFNDEF LCLLIB}
  FButtonCancel.Margins.Right := 5;
  FButtonCancel.Margins.Top := 5;
  FButtonCancel.Margins.Bottom := 5;
  FButtonCancel.Margins.Left := 5;
  {$ENDIF}
  FButtonCancel.OnClick := @DoButtonCancelClick;

  FButtonOK := TTMSFNCEditorButton.Create(FPanel);
//    FButtonOK.ModalResult := mrOk;
  FButtonOK.Parent := FPanel;
  FButtonOK.Text := TranslateTextEx(sTMSFNCChartEditorOK);
  {$IFDEF FMXLIB}
  FButtonOk.Align := TAlignLayout.Right;
  {$ENDIF}
  {$IFDEF CMNWEBLIB}
  FButtonOk.Align := alRight;
  FButtonOk.Left := 98;
  {$IFDEF VCLWEBLIB}
  FButtonOK.AlignWithMargins := True;
  {$ENDIF}
  {$ENDIF}
  {$IFNDEF LCLLIB}
  FButtonOK.Margins.Right := 0;
  FButtonOK.Margins.Top := 5;
  FButtonOK.Margins.Bottom := 5;
  FButtonOK.Margins.Left := 5;
  {$ENDIF}
  {$IFDEF LCLLIB}
  FButtonOK.BorderSpacing.Right := 0;
  FButtonOK.BorderSpacing.Top := 5;
  FButtonOK.BorderSpacing.Bottom := 5;
  FButtonOK.BorderSpacing.Left := 5;
  {$ENDIF}
  FButtonOK.OnClick := @DoButtonOKClick;

  FButtonApply := TTMSFNCEditorButton.Create(FPanel);
  FButtonApply.Parent := FPanel;
  FButtonApply.Text := TranslateTextEx(sTMSFNCChartEditorApply);
  {$IFDEF FMXLIB}
  FButtonApply.Align := TAlignLayout.Right;
  {$ENDIF}
  {$IFDEF CMNWEBLIB}
  FButtonApply.Align := alRight;
  FButtonApply.Left := 90;
  {$IFDEF VCLWEBLIB}
  FButtonApply.AlignWithMargins := True;
  {$ENDIF}
  {$ENDIF}
  {$IFDEF LCLLIB}
  FButtonApply.BorderSpacing.Right := 5;
  FButtonApply.BorderSpacing.Top := 5;
  FButtonApply.BorderSpacing.Bottom := 5;
  FButtonApply.BorderSpacing.Left := 5;
  {$ENDIF}
  {$IFNDEF LCLLIB}
  FButtonApply.Margins.Right := 5;
  FButtonApply.Margins.Top := 5;
  FButtonApply.Margins.Bottom := 5;
  FButtonApply.Margins.Left := 5;
  {$ENDIF}
  FButtonApply.OnClick := @DoButtonApplyClick;

  FButtonReset := TTMSFNCEditorButton.Create(FPanel);
  FButtonReset.Parent := FPanel;
  FButtonReset.Text := TranslateTextEx(sTMSFNCChartEditorReset);
  {$IFDEF FMXLIB}
  FButtonReset.Align := TAlignLayout.Right;
  {$ENDIF}
  {$IFDEF CMNWEBLIB}
  FButtonReset.Align := alRight;
  FButtonReset.Left := 70;
  {$IFDEF VCLWEBLIB}
  FButtonReset.AlignWithMargins := True;
  {$ENDIF}
  {$ENDIF}
  {$IFDEF LCLLIB}
  FButtonReset.BorderSpacing.Right := 5;
  FButtonReset.BorderSpacing.Top := 5;
  FButtonReset.BorderSpacing.Bottom := 5;
  FButtonReset.BorderSpacing.Left := 5;
  {$ENDIF}
  {$IFNDEF LCLLIB}
  FButtonReset.Margins.Right := 5;
  FButtonReset.Margins.Top := 5;
  FButtonReset.Margins.Bottom := 5;
  FButtonReset.Margins.Left := 5;
  {$ENDIF}
  FButtonReset.OnClick := @DoButtonResetClick;
end;

//procedure TTMSFNCChartEditor.CreateGeneralBottomPanel(AParent: TTMSFNCChartEditorParent);
//begin
//  FGeneralBottomPanel := TTMSFNCEditorPanel.Create(AParent);
//  {$IFDEF FMXLIB}
//  FGeneralBottomPanel.Align := TAlignLayout.Bottom;
//  FGeneralBottomPanel.PanelPosition := eppBottom;
//  {$ENDIF}
//  {$IFDEF CMNWEBLIB}
//  FGeneralBottomPanel.PanelPosition := eppCenter;
//  FGeneralBottomPanel.Align := alBottom;
//  {$ENDIF}
//  FGeneralBottomPanel.Parent := AParent;
//  FGeneralBottomPanel.Height := 37;

//  FLegacyBtn := TTMSFNCEditorButton.Create(FGeneralBottomPanel);
//  FLegacyBtn.Parent := FGeneralBottomPanel;
//  FLegacyBtn.Text := TranslateTextEx(sTMSFNCChartEditorLegacy);
//  {$IFDEF FMXLIB}
//  FLegacyBtn.Align := TAlignLayout.Right;
//  {$ENDIF}
//  {$IFDEF CMNWEBLIB}
//  FLegacyBtn.Align := alRight;
//  FLegacyBtn.Left := 99;
//  {$IFDEF VCLWEBLIB}
//  FLegacyBtn.AlignWithMargins := True;
//  {$ENDIF}
//  {$ENDIF}
//  {$IFDEF LCLLIB}
//  FLegacyBtn.BorderSpacing.Right := 5;
//  FLegacyBtn.BorderSpacing.Top := 5;
//  FLegacyBtn.BorderSpacing.Bottom := 5;
//  FLegacyBtn.BorderSpacing.Left := 5;
//  {$ENDIF}
//  {$IFNDEF LCLLIB}
//  FLegacyBtn.Margins.Right := 5;
//  FLegacyBtn.Margins.Top := 5;
//  FLegacyBtn.Margins.Bottom := 5;
//  FLegacyBtn.Margins.Left := 5;
//  {$ENDIF}
//  FLegacyBtn.Width := 165;
//  FLegacyBtn.OnClick := @DoButtonLegacyClick;
//end;

destructor TTMSFNCChartEditor.Destroy;
begin
  FBitmapEditor.Free;
  inherited;
end;

{$IFNDEF FMXLIB}
procedure TTMSFNCChartEditor.DoFormKeyDown(Sender: TObject; var Key: Word; Shift: TShiftState);
{$ENDIF}
{$IFDEF FMXLIB}
procedure TTMSFNCChartEditor.DoFormKeyDown(Sender: TObject; var Key: Word; var KeyChar: Char; Shift: TShiftState);
{$ENDIF}
begin
  inherited;

  if Key = KEY_ESCAPE then
    DoButtonCancelClick(Self)
  else if Key = KEY_RETURN then
    DoButtonOKClick(Self);
end;

procedure TTMSFNCChartEditor.DoAnnoItemSelectedChange(Sender: TObject;
  AIndex: Integer; AItem: TTMSFNCEditorListItem; ASelected: Boolean);
begin

end;

procedure TTMSFNCChartEditor.DoListBoxChange(Sender: TObject);
begin

end;

procedure TTMSFNCChartEditor.DoListBoxItemSelectedChange(Sender: TObject;
  AIndex: Integer; AItem: TTMSFNCEditorListItem; ASelected: Boolean);
begin

end;

procedure TTMSFNCChartEditor.DoPointsItemSelectedChange(Sender: TObject;
  AIndex: Integer; AItem: TTMSFNCEditorListItem; ASelected: Boolean);
begin

end;

//procedure TTMSFNCChartEditor.DoButtonLegacyClick(Sender: TObject);
//var
//  advE: TTMSFNCChartLegacyEditor;
//begin
//  SetWaitCursor;
//  advE := TTMSFNCChartLegacyEditor.Create(Self);
//  advE.Chart := FChart;
//  advE.Execute;
//  SetOldCursor;
//end;

procedure TTMSFNCChartEditor.DoButtonAppearanceClick(Sender: TObject);
var
  appE: TTMSFNCChartAppearanceEditor;
begin
  appE := TTMSFNCChartAppearanceEditor.Create(Self);
  appE.Chart := FChart;
  appE.Execute;
end;

procedure TTMSFNCChartEditor.DoButtonApplyClick(Sender: TObject);
begin
  FModified := False;
  FCopyChart.BeginUpdate;
  FCopyChart.Assign(FChart);
  FCopyChart.EndUpdate;

//  InitSeriesList(True, FSerieIndex);
end;

procedure TTMSFNCChartEditor.DoButtonResetClick(Sender: TObject);
begin
  {$IFNDEF WEBLIB}
  if Assigned(frm) and FModified then
  {$ENDIF}
  begin
    if ResetChartMessage then
    begin
      FModified := False;
      Chart.BeginUpdate;
      Chart.Assign(FCopyChart);
      Chart.EndUpdate;
//      InitSeriesList(True, FSerieIndex);
      Initialize;
    end;
  end;
end;

procedure TTMSFNCChartEditor.DoButtonSeriesClick(Sender: TObject);
var
  sE: TTMSFNCChartSeriesEditor;
begin
  SetWaitCursor;
  sE := TTMSFNCChartSeriesEditor.Create(Self);
  sE.Chart := FChart;
  sE.Execute;
  SetOldCursor;
end;

procedure TTMSFNCChartEditor.DoButtonTitleClick(Sender: TObject);
var
  tE: TTMSFNCChartTitleEditor;
begin
  tE := TTMSFNCChartTitleEditor.Create(Self);
  tE.Chart := FChart;
  tE.Execute;
end;

procedure TTMSFNCChartEditor.DoButtonTypeClick(Sender: TObject);
var
  tE: TTMSFNCChartTypeEditor;
begin
  tE := TTMSFNCChartTypeEditor.Create(Self);
  tE.Chart := FChart;
  tE.Execute;
end;

procedure TTMSFNCChartEditor.DoButtonXAxisClick(Sender: TObject);
var
  xE: TTMSFNCChartAxisEditor;
begin
  xE := TTMSFNCChartAxisEditor.Create(Self);
  xE.Chart := FChart;
  xE.Execute;
end;

procedure TTMSFNCChartEditor.DoButtonYAxisClick(Sender: TObject);
var
  yE: TTMSFNCChartAxisEditor;
begin
  yE := TTMSFNCChartAxisEditor.Create(Self, eatYAxis);
  yE.Chart := FChart;
  yE.Execute;
end;

{$IFDEF WEBLIB}
procedure TTMSFNCChartEditor.Execute(AProc: TModalResultProc = nil);
{$ELSE}
function TTMSFNCChartEditor.Execute: TModalResult;
{$ENDIF}
begin
  if not Assigned(Chart) then
  begin
    raise Exception.Create('No chart was assigned to the editor!');
    Exit;
  end;

  {$IFDEF WEBLIB}
  frm := TTMSFNCChartEditorForm.CreateDialogNew(Self, 'Chart Editor');
  {$ELSE}
  frm := TTMSFNCChartEditorForm.CreateNew(Application);
  frm.Caption := 'Chart Editor';
  frm.BorderIcons := [TBorderIcon.biSystemMenu, TBorderIcon.biMinimize];
  {$ENDIF}

  FCopyChart := TTMSFNCChart.Create(frm);
  FCopyChart.Assign(Chart);

  frm.Width := 500;
  frm.Height := 580;
  {$IFDEF FMXLIB}
  frm.Position := TFormPosition.ScreenCenter;
  frm.Fill.Kind := TBrushKind.Solid;
  if IsLightTheme then
    frm.Fill.Color := EDITORSUBBACKCOLORLIGHT
  else
    frm.Fill.Color := EDITORSUBBACKCOLORDARK;
  {$ENDIF}
  {$IFDEF CMNLIB}
  frm.KeyPreview := True;
  {$ENDIF}
  {$IFNDEF LCLLIB}
  frm.OnKeyDown := DoFormKeyDown;
  {$ENDIF}
  {$IFDEF LCLLIB}
  frm.OnKeyDown := @DoFormKeyDown;
  {$ENDIF}
  {$IFDEF CMNWEBLIB}
  frm.Position := poScreenCenter;
  {$ENDIF}
  {$IFNDEF WEBLIB}
  BuildEditor(frm);
  frm.ActiveControl := FGeneralPanel;
  {$ENDIF}
  TTMSFNCUtils.ScaleForCurrentDPI(frm);
  {$IFNDEF WEBLIB}
  Result := frm.ShowModal;
  if (Result <> mrOk) and Assigned(Chart) then
  begin
    Chart.Assign(nil);
    Chart.BeginUpdate;
    Chart.Assign(FCopyChart);
    Chart.EndUpdate;
    FCopyChart := nil;
  end;
  frm.Free;
  {$ELSE}
  frm.ShowModal(
  procedure(AResult: TModalResult)
  begin
    if (AResult <> mrOk) and Assigned(Chart) then
    begin
      Chart.Assign(nil);
      Chart.BeginUpdate;
      Chart.Assign(FCopyChart);
      Chart.EndUpdate;
      FCopyChart := nil;
    end;
    frm := nil;
    if Assigned(AProc) then
      AProc(AResult);
  end);
  {$ENDIF}
end;

function TTMSFNCChartEditor.GetDocURL: string;
begin
  Result := TTMSFNCBaseDocURL + 'tmsfncchart';
end;

function TTMSFNCChartEditor.GetInstance: NativeUInt;
begin
  Result := HInstance;
end;

function TTMSFNCChartEditor.GetTipsURL: string;
begin
  Result := 'https://www.tmssoftware.com/site/tmsfncchart.asp?s=faq';
end;

procedure TTMSFNCChartEditor.Initialize;
begin

end;

function TTMSFNCChartEditor.SaveChartMessage: Boolean;
var
  res: Integer;
begin
  {$IFNDEF WEBLIB}
  Result := False;
  res := TTMSFNCUtils.Message(sTMSFNCChartEditorSaveChartMessage, TMsgDlgType.mtConfirmation, [TMsgDlgBtn.mbYes, TMsgDlgBtn.mbNo], 0);
  if res = VALUE_MBYES then
  {$ENDIF}
    Result := True;
end;

procedure TTMSFNCChartEditor.SetAppearance;
var
  {$IFDEF VCLLIB}
  LDetails: TThemedElementDetails;
  clr, fc: TTMSFNCGraphicsColor;
  {$ENDIF}
  okfntCol, fntCol, fillCol, primCol: TTMSFNCGraphicsColor;
  SubPanelFillCol, SubPanelStrokecol, MainPanelCol: TTMSFNCGraphicsColor;

  procedure SetEditorButton(ABtn: TTMSFNCEditorButton);
  begin
    {$IFDEF VCLLIB}
    if TTMSFNCChartOpen(FChart).VCLStylesEnabled then
    begin
      SetEditorIconButtonAppearance(ABtn, primCol, EDITORBUTTONROUNDING, fntCol, fillCol);
      if (fc <> clNone) then
      begin
        if Assigned(ABtn.Bitmap.SVG) then
          ABtn.Bitmap.SVG.CustomFillColor := fc;
        ABtn.Appearance.Font.Color := fc;
      end;
    end
    else
    {$ENDIF}
      SetEditorIconButtonAppearance(ABtn);

    ABtn.Appearance.TextAlignVertical := gtaLeading;
    TTMSFNCUtils.SetFontSize(ABtn.Appearance.Font, 14);
    TTMSFNCUtils.SetFontSize(ABtn.Appearance.HoverFont, 14);
    TTMSFNCUtils.SetFontSize(ABtn.Appearance.DownFont, 14);

    ABtn.DownBitmap.Assign(ABtn.Bitmap);
    {$IFNDEF WEBLIB}
    if Assigned(ABtn.DownBitmap.SVG) then
      ABtn.DownBitmap.SVG.CustomFillColor := ABtn.Appearance.SelectedFont.Color;
    {$ENDIF}
  end;
begin
  primCol := EDITORPRIMCOLOR;
  fillCol := EDITORAUTOCOLOR;
  fntCol := EDITORAUTOCOLOR;
  okfntCol := EDITOROKFONTCOLOR;
  SubPanelStrokeCol := EDITORAUTOCOLOR;
  SubPanelFillCol := EDITORAUTOCOLOR;
  MainPanelCol := EDITORAUTOCOLOR;
  {$IFDEF VCLLIB}
  fc := gcNull;

  if TTMSFNCChartOpen(FChart).VCLStylesEnabled then
  begin
    clr := StyleServices.GetStyleColor(scButtonHot);
    if clr <> clNone then
      primCol := clr;

    LDetails := StyleServices.GetElementDetails(ttbButtonPressed);
    if StyleServices.GetElementColor(LDetails, ecTextColor, clr) and (clr <> clNone) then
      okfntCol := clr;

    LDetails := StyleServices.GetElementDetails(ttbButtonHot);
    if StyleServices.GetElementColor(LDetails, ecTextColor, clr) and (clr <> clNone) then
    begin
      fc := clr;
//      okfntCol := clr;
    end;

    LDetails := StyleServices.GetElementDetails(ttbButtonNormal);

    if StyleServices.GetElementColor(LDetails, ecFillColor, clr) and (clr <> clNone) then
      fillCol := clr;

    if StyleServices.GetElementColor(LDetails, ecTextColor, clr) and (clr <> clNone) then
      fntCol := clr;

    LDetails := StyleServices.GetElementDetails(tpPanelBackground);
    if StyleServices.GetElementColor(LDetails, ecFillColor, clr) and (clr <> clNone) then
      SubPanelFillCol := clr;
    if StyleServices.GetElementColor(LDetails, ecBorderColor, clr) and (clr <> clNone) then
      SubPanelStrokeCol := clr;

    clr := StyleServices.GetSystemColor(clBtnFace);
    if (clr <> clNone) then
    begin
      MainPanelCol := clr;
    end;
  end;
  FButtonOk.StyleElements := FButtonOk.StyleElements - [seClient];
  FButtonApply.StyleElements := FButtonApply.StyleElements - [seClient];
  FButtonCancel.StyleElements := FButtonCancel.StyleElements - [seClient];
  FButtonReset.StyleElements := FButtonReset.StyleElements - [seClient];

  FGeneralPanel.StyleElements := FGeneralPanel.StyleElements - [seClient];
  FPanel.StyleElements := FPanel.StyleElements - [seClient];
  FTypeBtn.StyleElements := FTypeBtn.StyleElements - [seClient];
  FAppearanceBtn.StyleElements := FAppearanceBtn.StyleElements - [seClient];
  FLegendBtn.StyleElements := FLegendBtn.StyleElements - [seClient];
  FTitleBtn.StyleElements := FTitleBtn.StyleElements - [seClient];
  FXAxisBtn.StyleElements := FXAxisBtn.StyleElements - [seClient];
  FYAxisBtn.StyleElements := FYAxisBtn.StyleElements - [seClient];
  FSeriesBtn.StyleElements := FSeriesBtn.StyleElements - [seClient];
//  FLegacyBtn.StyleElements := FLegacyBtn.StyleElements - [seClient];
  {$ENDIF}

  SetEditorOKButtonAppearance(FButtonOk,primCol, EDITORBUTTONROUNDING, okfntCol);
  SetEditorCancelButtonAppearance(FButtonApply, primCol, EDITORBUTTONROUNDING, fntCol, fillCol);
  SetEditorCancelButtonAppearance(FButtonReset, primCol, EDITORBUTTONROUNDING, fntCol, fillCol);
//  SetEditorCancelButtonAppearance(FLegacyBtn, primCol, EDITORBUTTONROUNDING, fntCol, fillCol);
  SetEditorCancelButtonAppearance(FButtonCancel, primCol, EDITORBUTTONROUNDING, fntCol, fillCol);

  SetEditorSubPanelAppearance(FGeneralPanel, SubPanelFillCol, SubPanelStrokeCol);
  SetEditorBackPanelAppearance(FPanel, MainPanelCol, MainPanelCol);
//  SetEditorSubPanelAppearance(FGeneralBottomPanel, SubPanelFillCol, SubPanelStrokeCol);

  SetEditorButton(FTypeBtn);
  SetEditorButton(FAppearanceBtn);
  SetEditorButton(FLegendBtn);
  SetEditorButton(FTitleBtn);
  SetEditorButton(FXAxisBtn);
  SetEditorButton(FYAxisBtn);
  SetEditorButton(FSeriesBtn);
end;

procedure TTMSFNCChartEditor.SetChart(const Value: TTMSFNCChart);
begin
  FChart := Value;
end;

{$IFDEF CMNLIB}
procedure TTMSFNCChartEditor.SetOldCursor;
begin
  Screen.Cursor := FOldCursor;
end;

procedure TTMSFNCChartEditor.SetWaitCursor;
begin
  FOldCursor := Screen.Cursor;
  Screen.Cursor := crHourGlass;
end;
{$ENDIF}

{$IFDEF WEBLIB}
procedure TTMSFNCChartEditor.SetOldCursor;
begin
  //
end;

procedure TTMSFNCChartEditor.SetWaitCursor;
begin
  //
end;
{$ENDIF}

{$IFDEF FMXLIB}
procedure TTMSFNCChartEditor.SetOldCursor;
var
  CS: IFMXCursorService;
begin
  if TPlatformServices.Current.SupportsPlatformService(IFMXCursorService) then
    CS := TPlatformServices.Current.GetPlatformService(IFMXCursorService) as IFMXCursorService;

  if Assigned(CS) then
    CS.SetCursor(FOldCursor);
end;

procedure TTMSFNCChartEditor.SetWaitCursor;
var
  CS: IFMXCursorService;
begin
  if TPlatformServices.Current.SupportsPlatformService(IFMXCursorService) then
    CS := TPlatformServices.Current.GetPlatformService(IFMXCursorService) as IFMXCursorService;

  if Assigned(CS) then
  begin
    FOldCursor := CS.GetCursor;
    CS.SetCursor(crHourGlass);
  end;
end;
{$ENDIF}


{$IFDEF WEBLIB}

{ TTMSFNCChartEditorForm }

constructor TTMSFNCChartEditorForm.CreateDialogNew(AChartEditor: TTMSFNCChartEditor; ACaption: string);
begin
  FChartEditor := AChartEditor;
  inherited CreateDialogNew(ACaption);
end;

procedure TTMSFNCChartEditorForm.LoadDFMValues;
begin
  inherited LoadDFMValues;
  if Assigned(FChartEditor) then
  begin
    FChartEditor.BuildEditor(Self);
    ActiveControl := FChartEditor.FTypeBtn;
  end;
end;

procedure TTMSFNCChartEditorForm.Loaded;
var
  css: string;
begin
  inherited;

  css := Application.IDECSS;

  if (css <> '') then
  begin
    AddCSS('IDECSS', css);
    ElementClassName := 'IDEBkg';
    CaptionElement['class'] := 'IDECaption IDEFont';
    if Assigned(FChartEditor) then
      FChartEditor.ApplyCSS(css);
  end;
end;

{$ENDIF}

{$IFDEF WEBLIB}
initialization
begin
  TTMSFNCBitmap.CreateFromResource(TTMSFNCCHARTAPPEARANCEBITMAP);
  TTMSFNCBitmap.CreateFromResource(TTMSFNCCHARTXAXISBITMAP);
  TTMSFNCBitmap.CreateFromResource(TTMSFNCCHARTYAXISBITMAP);
  TTMSFNCBitmap.CreateFromResource(TTMSFNCCHARTTITLEBITMAP);
  TTMSFNCBitmap.CreateFromResource(TTMSFNCCHARTSERIESBITMAP);
  TTMSFNCBitmap.CreateFromResource(TTMSFNCCHARTLEGENDBITMAP);
    TTMSFNCBitmap.CreateFromResource(TTMSFNCCHARTTYPEBITMAP);
end;
{$ENDIF}

end.
